export const notebookData = {
  hr: {
    pages: [
      {
        description: "about self",
        content: [
          {
            type: "text",
            value:
              "Hello, my name is Amit Kumar. I am a Software Engineer with over 3.5 years of experience in developing APIs and building scalable web and mobile applications. My expertise includes JavaScript, React.js, Node.js, and React Native, with a strong focus on backend development using Express.js and database management with MySQL, MongoDB, and DynamoDB.\nCurrently, I am working at Phnk Networks., where I lead full-stack development projects, integrate AI-driven features, optimize databases, and implement real-time communication systems using Kafka. Previously, at Kalpkriti Pvt. Ltd., I worked on API development, automation using Python, and data analysis with BigQuery.\nI am proficient in cloud services like AWS, have experience integrating payment gateways such as Razorpay and Google Play, and have also contributed to open-source projects, including npm packages for environment management and Markdown conversion.\nI am always eager to take on new challenges and continuously enhance my skills. I am excited about opportunities that allow me to contribute effectively while growing professionally.",
          },
        ],
      },
      {
        description: "reason for leaving company",
        content: [
          {
            type: "text",
            value:
              "I have spent 2.5 years in my current company, where I have learned a lot and gained valuable experience. Now, I feel ready to take on new challenges and explore opportunities that will help me further develop my skills and grow professionally.",
          },
        ],
      },
      {
        description: "when you join",
        content: [
          {
            type: "text",
            value:
              "I can join in 10 days, as I need to complete my transition and settle my responsibilities at my current company.",
          },
        ],
      },
    ],
  },
  python: {
    pages: [
      {
        description: "Introduction to Python",
        content: [
          {
            type: "text",
            value:
              "Python is a high-level, interpreted programming language known for its simplicity and readability. It is widely used in web development, data science, artificial intelligence, and more.",
          },
          { type: "code", value: "print('Hello, Python!')" },
        ],
      },
      {
        description: "Python Variables & Data Types",
        content: [
          {
            type: "text",
            value:
              "Python variables are containers for storing data values. The data types include strings, numbers, booleans, lists, tuples, dictionaries, and more.",
          },
          {
            type: "code",
            value: "message = 'Hello, World!'\nnumber = 42\nis_true = True",
          },
        ],
      },
      {
        description: "Python Functions & Lambda Functions",
        content: [
          {
            type: "text",
            value:
              "Functions in Python are blocks of reusable code that perform a specific task. Lambda functions are anonymous functions defined using the lambda keyword.",
          },
          {
            type: "code",
            value:
              "def greet(name):\n    return f'Hello, {name}!'\n\nlambda name: f'Hello, {name}!'",
          },
        ],
      },
      {
        description: "Python Lists & List Comprehensions",
        content: [
          {
            type: "text",
            value:
              "Lists in Python are ordered collections of items. List comprehensions provide a concise way to create lists based on existing lists.",
          },
          {
            type: "code",
            value:
              "numbers = [1, 2, 3, 4, 5]\nnew_numbers = [n * 2 for n in numbers]",
          },
        ],
      },
      {
        description: "Python Dictionaries & Dictionary Methods",
        content: [
          {
            type: "text",
            value:
              "Dictionaries in Python are unordered collections of key-value pairs. Dictionary methods like get, keys, values, and items are used for dictionary manipulation.",
          },
          {
            type: "code",
            value:
              "person = {'name': 'Alice', 'age': 30}\nprint(person['name'])",
          },
        ],
      },
      {
        description: "Control Flow & Conditional Statements",
        content: [
          {
            type: "text",
            value:
              "Control flow statements like if, elif, and else are used to make decisions in Python based on conditions.",
          },
          {
            type: "code",
            value:
              "if x > 0:\n    print('Positive')\nelif x < 0:\n    print('Negative')\nelse:\n    print('Zero')",
          },
        ],
      },
      {
        description: "Loops & Iteration",
        content: [
          {
            type: "text",
            value:
              "Loops in Python are used to iterate over sequences like lists, tuples, and dictionaries. Common loop types include for loops and while loops.",
          },
          {
            type: "code",
            value:
              "for i in range(5):\n    print(i)\n\nwhile x < 10:\n    print(x)\n    x += 1",
          },
        ],
      },
      {
        description: "File Handling & I/O Operations",
        content: [
          {
            type: "text",
            value:
              "Python provides built-in functions and modules for file handling and input/output operations. This includes reading from and writing to files.",
          },
          {
            type: "code",
            value:
              "with open('file.txt', 'r') as file:\n    data = file.read()\n\nwith open('output.txt', 'w') as file:\n    file.write('Hello, File!')",
          },
        ],
      },
      {
        description: "Modules & Packages",
        content: [
          {
            type: "text",
            value:
              "Modules in Python are files containing Python code that can be imported and used in other Python files. Packages are directories containing multiple modules.",
          },
          { type: "code", value: "import math\nfrom datetime import datetime" },
        ],
      },
      {
        description: "Error Handling & Exceptions",
        content: [
          {
            type: "text",
            value:
              "Error handling in Python is done using try, except, else, and finally blocks. Exceptions are raised when errors occur during program execution.",
          },
          {
            type: "code",
            value:
              "try:\n    result = x / y\nexcept ZeroDivisionError as e:\n    print('Error:', e)",
          },
        ],
      },
    ],
  },
  javascript: {
    pages: [
      {
        description: "What is JavaScript?",
        content: [
          {
            type: "text",
            value:
              "JavaScript is a high-level, interpreted programming language used to create interactive web applications. It supports multiple paradigms, including object-oriented, imperative, and functional programming. JavaScript runs in web browsers and is widely used for dynamic content, games, server-side applications, and mobile development.",
          },
          {
            type: "code",
            value: "<script>\n  document.write('Hello, World!');\n</script>",
          },
        ],
      },
      {
        description: "Difference between let, const, and var",
        content: [
          {
            type: "text",
            value:
              "`var`: Function-scoped, hoisted, can be re-declared and updated, but not recommended due to potential bugs.",
          },
          {
            type: "text",
            value:
              "`let`: Block-scoped, hoisted but not initialized, cannot be re-declared, making it safer for variable management.",
          },
          {
            type: "text",
            value:
              "`const`: Block-scoped, hoisted but not initialized, cannot be updated or re-declared, ensuring immutable references.",
          },
          {
            type: "code",
            value: "var x = 10;\nlet y = 20;\nconst z = 30;",
          },
        ],
      },
      {
        description: "How does type coercion work in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "Type coercion automatically converts values from one type to another, either implicitly or explicitly.",
          },
          {
            type: "text",
            value:
              "Implicit coercion occurs in operations, such as `1 + '2'` resulting in `'12'` (string concatenation).",
          },
          {
            type: "text",
            value:
              "Explicit coercion uses functions like `Number()`, `String()`, and `Boolean()` to convert types manually.",
          },
          {
            type: "code",
            value:
              "console.log(1 + '2'); // '12'\nconsole.log(Number('2') + 1); // 3",
          },
        ],
      },
      {
        description: "Difference between `==` and `===`",
        content: [
          {
            type: "text",
            value:
              "`==` (loose equality) performs type conversion before comparison.",
          },
          {
            type: "text",
            value:
              "`===` (strict equality) does not perform type conversion and compares both value and type.",
          },
          {
            type: "code",
            value:
              "console.log(1 == '1'); // true\nconsole.log(1 === '1'); // false",
          },
        ],
      },
      {
        description: "What are truthy and falsy values?",
        content: [
          {
            type: "text",
            value:
              "Falsy values: `false`, `0`, `''`, `null`, `undefined`, `NaN` (evaluated as false in boolean contexts).",
          },
          {
            type: "text",
            value:
              "Truthy values: Any value that is not falsy, such as non-empty strings, numbers, and objects.",
          },
          {
            type: "code",
            value:
              "if (0) console.log('Falsy'); // Won't execute\nif ('Hello') console.log('Truthy'); // Executes",
          },
        ],
      },
      {
        description: "What is the `typeof` operator?",
        content: [
          {
            type: "text",
            value:
              "The `typeof` operator returns a string representing the type of a value.",
          },
          {
            type: "text",
            value:
              "Common return values: `'string'`, `'number'`, `'boolean'`, `'object'`, `'undefined'`.",
          },
          {
            type: "code",
            value:
              "console.log(typeof 42); // 'number'\nconsole.log(typeof {}); // 'object'",
          },
        ],
      },
      {
        description: "JavaScript Data Types",
        content: [
          {
            type: "text",
            value:
              "JavaScript has two main types of data: primitive and non-primitive.",
          },
          {
            type: "text",
            value:
              "Primitive types: `Number`, `String`, `Boolean`, `Undefined`, `Null`, `BigInt`, `Symbol`.",
          },
          {
            type: "text",
            value: "Non-primitive types: `Object`, `Function`, `Array`.",
          },
        ],
      },
      {
        description: "Difference between `null`, `undefined`, and `''`",
        content: [
          {
            type: "text",
            value: "`null`: Represents an intentional absence of a value.",
          },
          {
            type: "text",
            value:
              "`undefined`: A variable declared but not assigned any value.",
          },
          {
            type: "text",
            value: "`''`: An empty string, but still a defined value.",
          },
        ],
      },
      {
        description: "How to check if a variable is an array?",
        content: [
          {
            type: "text",
            value: "Different ways to check if a variable is an array:",
          },
          {
            type: "text",
            value: "- `Array.isArray(value)` (recommended)",
          },
          {
            type: "text",
            value: "- `value instanceof Array`",
          },
          {
            type: "text",
            value: "- `value.constructor === Array`",
          },
          {
            type: "text",
            value:
              "- `Object.prototype.toString.call(value) === '[object Array]'`",
          },
          {
            type: "code",
            value:
              "console.log(Array.isArray([])); // true\nconsole.log([] instanceof Array); // true",
          },
        ],
      },
      {
        description: "What is scope in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "Scope determines the accessibility of variables in JavaScript.",
          },
          {
            type: "text",
            value: "Two main types:",
          },
          {
            type: "text",
            value:
              "- **Global Scope**: Variables accessible anywhere in the script.",
          },
          {
            type: "text",
            value:
              "- **Local Scope**: Variables accessible only within a function or block.",
          },
          {
            type: "code",
            value:
              "let name = 'John';\nfunction greet() {\n    console.log('Hello ' + name + '!');\n}\ngreet(); // 'Hello John!'\nconsole.log(name); // 'John'",
          },
          {
            type: "code",
            value:
              "function greetLocal() {\n    let name = 'Doe';\n    console.log('Hello ' + name + '!');\n}\ngreetLocal(); // 'Hello Doe'\n// console.log(name); // ReferenceError",
          },
        ],
      },
      {
        description: "Function scope vs. Block scope",
        content: [
          {
            type: "text",
            value:
              "Function Scope: Variables declared inside a function are accessible only within that function.",
          },
          {
            type: "text",
            value:
              "Block Scope: Variables declared with `let` or `const` inside a block `{}` are accessible only within that block.",
          },
          {
            type: "code",
            value:
              "function greetFunc() {\n    let city = 'New York';\n    console.log(city);\n}\ngreetFunc(); // 'New York'\n// console.log(city); // ReferenceError",
          },
          {
            type: "code",
            value:
              "if (true) {\n    let country = 'USA';\n    console.log(country); // 'USA'\n}\n// console.log(country); // ReferenceError",
          },
        ],
      },
      {
        description: "What is hoisting in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "Hoisting moves variable and function declarations to the top of their scope before execution.",
          },
          {
            type: "text",
            value: "- `var` is hoisted but initialized as `undefined`.",
          },
          {
            type: "text",
            value:
              "- `let` and `const` are hoisted but remain in the Temporal Dead Zone (TDZ) until assigned.",
          },
          {
            type: "text",
            value:
              "- Function declarations are fully hoisted and can be called before they appear in the code.",
          },
          {
            type: "code",
            value: "console.log(name); // undefined\nvar name = 'John';",
          },
          {
            type: "code",
            value:
              "// console.log(age); // ReferenceError: Cannot access 'age' before initialization\nlet age = 25;",
          },
          {
            type: "code",
            value:
              "console.log(greet()); // 'Hello!'\nfunction greet() {\n    return 'Hello!';\n}",
          },
        ],
      },
      {
        description: "Hoisting with var, let, and const",
        content: [
          {
            type: "text",
            value:
              "Hoisting moves declarations to the top of their scope before execution.",
          },
          {
            type: "text",
            value:
              "- **var**: Hoisted and initialized with `undefined`, accessible before declaration.",
          },
          {
            type: "text",
            value:
              "- **let & const**: Hoisted but not initialized, accessing before declaration throws an error.",
          },
          {
            type: "code",
            value: "console.log(city); // undefined\nvar city = 'Paris';",
          },
          {
            type: "code",
            value:
              "// console.log(country); // ReferenceError: Cannot access 'country' before initialization\nlet country = 'France';",
          },
        ],
      },
      {
        description: "What is the Temporal Dead Zone (TDZ)?",
        content: [
          {
            type: "text",
            value:
              "The period between variable hoisting and initialization where access causes a ReferenceError.",
          },
          {
            type: "text",
            value: "Applies to `let` and `const`, but not `var`.",
          },
          {
            type: "code",
            value:
              "console.log(score); // ReferenceError: Cannot access 'score' before initialization\nlet score = 100;",
          },
        ],
      },
      {
        description: "What is a function in JavaScript?",
        content: [
          {
            type: "text",
            value: "A reusable block of code that executes when called.",
          },
          {
            type: "text",
            value: "Functions can take parameters and return a value.",
          },
          {
            type: "text",
            value: "Defined using the `function` keyword.",
          },
          {
            type: "code",
            value:
              "function sayHello() {\n    console.log('Hello, world!');\n}\nsayHello(); // 'Hello, world!'",
          },
        ],
      },
      {
        description: "What are first-class functions?",
        content: [
          {
            type: "text",
            value:
              "Functions in JavaScript are first-class citizens, meaning they can:",
          },
          {
            type: "text",
            value: "- Be assigned to variables.",
          },
          {
            type: "text",
            value: "- Be passed as arguments.",
          },
          {
            type: "text",
            value: "- Be returned from functions.",
          },
          {
            type: "code",
            value:
              "const greetFunc = function() {\n    return 'Hello!';\n};\nconsole.log(greetFunc()); // 'Hello!'",
          },
        ],
      },
      {
        description: "What is a higher-order function?",
        content: [
          {
            type: "text",
            value:
              "A function that takes another function as an argument or returns a function.",
          },
          {
            type: "code",
            value:
              "function greet() {\n    return function() {\n        console.log('Hello World!');\n    };\n}\nlet sayHello = greet();\nsayHello(); // 'Hello World!'",
          },
        ],
      },
      {
        description: "What is a closure in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "A closure is a function that retains access to its outer function’s variables even after the outer function has executed.",
          },
          {
            type: "code",
            value:
              "function greet() {\n    let name = 'John';\n    return function() {\n        console.log('Hello ' + name + '!');\n    };\n}\nlet sayHello = greet();\nsayHello(); // 'Hello John!'",
          },
        ],
      },
      {
        description: "What is the use of closures in JavaScript?",
        content: [
          {
            type: "text",
            value: "Closures are used for:",
          },
          {
            type: "text",
            value: "- Data encapsulation (private variables)",
          },
          {
            type: "text",
            value: "- Creating factory functions",
          },
          {
            type: "text",
            value: "- Implementing module patterns",
          },
          {
            type: "text",
            value: "- Event handlers & callbacks",
          },
          {
            type: "code",
            value:
              "function counter() {\n    let count = 0;\n    return function() {\n        count++;\n        console.log(count);\n    };\n}\nlet increment = counter();\nincrement(); // 1\nincrement(); // 2\nincrement(); // 3",
          },
        ],
      },
      {
        description: "Function Expression vs. Function Declaration",
        content: [
          {
            type: "text",
            value: "**Function Expression:**",
          },
          {
            type: "text",
            value: "- Assigned to a variable.",
          },
          {
            type: "text",
            value: "- Not hoisted.",
          },
          {
            type: "text",
            value: "- Created at runtime.",
          },
          {
            type: "text",
            value: "- Can be passed as an argument or returned.",
          },
          {
            type: "code",
            value:
              "let greet = function() {\n    console.log('Hello World!');\n};\ngreet(); // 'Hello World!'",
          },
          {
            type: "text",
            value: "**Function Declaration:**",
          },
          {
            type: "text",
            value: "- Declared with `function` keyword.",
          },
          {
            type: "text",
            value: "- Hoisted (can be called before declaration).",
          },
          {
            type: "text",
            value: "- Defined at parse time.",
          },
          {
            type: "code",
            value:
              "function greet() {\n    console.log('Hello World!');\n}\ngreet(); // 'Hello World!'",
          },
        ],
      },
      {
        description: "Arrow Functions vs. Regular Functions",
        content: [
          {
            type: "text",
            value: "**Arrow Functions:**",
          },
          {
            type: "text",
            value: "- Shorter syntax",
          },
          {
            type: "text",
            value: "- No `this`, `arguments`, or `super`",
          },
          {
            type: "text",
            value: "- Cannot be constructors",
          },
          {
            type: "code",
            value:
              "let greet = () => console.log('Hello World!');\ngreet(); // 'Hello World!'",
          },
          {
            type: "text",
            value: "**Regular Functions:**",
          },
          {
            type: "text",
            value: "- Have their own `this`, `arguments`",
          },
          {
            type: "text",
            value: "- Can be used as constructors",
          },
          {
            type: "code",
            value:
              "function greet() {\n    console.log('Hello World!');\n}\ngreet(); // 'Hello World!'",
          },
        ],
      },
      {
        description: "What is the `arguments` object?",
        content: [
          {
            type: "text",
            value: "- An array-like object containing function arguments.",
          },
          {
            type: "text",
            value: "- Available in regular functions, not in arrow functions.",
          },
          {
            type: "code",
            value:
              "function sum() {\n    let total = 0;\n    for (let i = 0; i < arguments.length; i++) {\n        total += arguments[i];\n    }\n    return total;\n}\nconsole.log(sum(1, 2, 3)); // 6",
          },
        ],
      },
      {
        description: "Rest Parameter",
        content: [
          {
            type: "text",
            value: "- Captures an indefinite number of arguments as an array.",
          },
          {
            type: "text",
            value: "- Syntax: `...args`",
          },
          {
            type: "code",
            value:
              "function sum(...args) {\n    return args.reduce((total, current) => total + current, 0);\n}\nconsole.log(sum(1, 2, 3)); // 6",
          },
        ],
      },
      {
        description: "Spread Operator",
        content: [
          {
            type: "text",
            value: "- Expands an array into individual elements.",
          },
          {
            type: "text",
            value: "- Syntax: `...array`",
          },
          {
            type: "code",
            value:
              "function sum(a, b, c) {\n    return a + b + c;\n}\nlet numbers = [1, 2, 3];\nconsole.log(sum(...numbers)); // 6",
          },
        ],
      },
      {
        description: "Default Parameters",
        content: [
          {
            type: "text",
            value: "- Assigns a default value if no argument is passed.",
          },
          {
            type: "code",
            value:
              "function greet(name = 'World') {\n    console.log('Hello ' + name + '!');\n}\ngreet(); // 'Hello World!'\ngreet('John'); // 'Hello John!'",
          },
        ],
      },
      {
        description: "The `this` Keyword",
        content: [
          {
            type: "text",
            value: "- Refers to the object that is executing the function.",
          },
          {
            type: "text",
            value: "- Depends on function execution context.",
          },
          {
            type: "code",
            value:
              "let person = {\n    name: 'John',\n    greet: function() {\n        console.log('Hello ' + this.name + '!');\n    }\n};\nperson.greet(); // 'Hello John!'",
          },
        ],
      },
      {
        description: "Different Ways to Set `this`",
        content: [
          {
            type: "text",
            value:
              "- **Implicit Binding**: `this` refers to the object before the dot.",
          },
          {
            type: "text",
            value:
              "- **Explicit Binding**: `call()`, `apply()`, `bind()` explicitly set `this`.",
          },
          {
            type: "text",
            value:
              "- **New Binding**: `new` creates a new object and sets `this`.",
          },
          {
            type: "text",
            value:
              "- **Default Binding**: If not bound, `this` refers to the global object.",
          },
        ],
      },
      {
        description: "Call, Apply, and Bind Methods",
        content: [
          {
            type: "text",
            value:
              "- **call()**: Calls a function with a specific `this` and arguments individually.",
          },
          {
            type: "text",
            value:
              "- **apply()**: Calls a function with `this` and arguments as an array.",
          },
          {
            type: "text",
            value:
              "- **bind()**: Returns a new function with `this` set to the provided value.",
          },
        ],
      },
      {
        description: "Recursion",
        content: [
          {
            type: "text",
            value:
              "- Recursion is a technique where a function calls itself to solve problems with smaller subproblems.",
          },
          {
            type: "code",
            value:
              "function factorial(n) {\n    return n === 0 ? 1 : n * factorial(n - 1);\n}\nconsole.log(factorial(5)); // 120",
          },
        ],
      },
      {
        description: "Callback Functions",
        content: [
          {
            type: "text",
            value:
              "- A callback is a function passed as an argument to another function, commonly used in asynchronous operations.",
          },
          {
            type: "code",
            value:
              "function greet(name, callback) {\n    console.log(`Hello ${name}!`);\n    callback();\n}\ngreet('John', () => console.log('How are you?'));",
          },
        ],
      },
      {
        description: "Promises",
        content: [
          {
            type: "text",
            value:
              "- A promise represents the eventual result of an asynchronous operation, handling success and failure.",
          },
          {
            type: "code",
            value:
              "let promise = new Promise(resolve => setTimeout(() => resolve('Hello World!'), 1000));\npromise.then(console.log);",
          },
        ],
      },
      {
        description: "Async/Await",
        content: [
          {
            type: "text",
            value:
              "- async/await simplifies asynchronous code, making it look synchronous, built on promises.",
          },
          {
            type: "code",
            value:
              "async function greet() {\n    return 'Hello World!';\n}\ngreet().then(console.log);",
          },
        ],
      },
      {
        description: "Event Loop",
        content: [
          {
            type: "text",
            value:
              "- The event loop manages asynchronous operations, ensuring non-blocking execution.",
          },
          {
            type: "code",
            value:
              "console.log('Hello World!');\nsetTimeout(() => console.log('How are you?'), 1000);\nconsole.log('Goodbye!');",
          },
        ],
      },
      {
        description: "Synchronous vs. Asynchronous Code",
        content: [
          {
            type: "text",
            value:
              "- Synchronous executes sequentially (blocking); asynchronous allows non-blocking execution.",
          },
          {
            type: "code",
            value:
              "console.log('Sync:');\nconsole.log('Hello');\nconsole.log('Goodbye');\n\nconsole.log('Async:');\nconsole.log('Hello');\nsetTimeout(() => console.log('How are you?'), 1000);\nconsole.log('Goodbye');",
          },
        ],
      },
      {
        description: "Promise vs. Async/Await",
        content: [
          {
            type: "text",
            value:
              "- Promises use `.then()` and `.catch()`; async/await makes code more readable.",
          },
          {
            type: "code",
            value:
              "let promiseEx = new Promise(resolve => setTimeout(() => resolve('Hello!'), 1000));\npromiseEx.then(console.log);\n\nasync function asyncExample() {\n    console.log(await promiseEx);\n}\nasyncExample();",
          },
        ],
      },
      {
        description: "Array Methods: map, filter, reduce",
        content: [
          {
            type: "text",
            value: "- `map` transforms each array element.",
          },
          {
            type: "text",
            value: "- `filter` returns elements meeting a condition.",
          },
          {
            type: "text",
            value: "- `reduce` accumulates values into one result.",
          },
        ],
      },
      {
        description: "find vs. findIndex",
        content: [
          {
            type: "text",
            value:
              "- `find` returns the first matching element; `findIndex` returns its index.",
          },
        ],
      },
      {
        description: "some vs. every",
        content: [
          {
            type: "text",
            value:
              "- `some` checks if any element meets a condition; `every` checks if all do.",
          },
        ],
      },
      {
        description: "slice vs. splice",
        content: [
          {
            type: "text",
            value: "- `slice` extracts elements without modifying the array.",
          },
          {
            type: "text",
            value:
              "- `splice` modifies the array by removing or replacing elements.",
          },
        ],
      },
      {
        description: "push vs. pop",
        content: [
          {
            type: "text",
            value:
              "- `push`: Adds elements to the end of an array, returns new length, mutates the array.",
          },
          {
            type: "text",
            value:
              "- `pop`: Removes the last element, returns it, mutates the array.",
          },
        ],
      },
      {
        description: "unshift vs. shift",
        content: [
          {
            type: "text",
            value:
              "- `unshift`: Adds elements to the beginning, returns new length, mutates the array.",
          },
          {
            type: "text",
            value:
              "- `shift`: Removes the first element, returns it, mutates the array.",
          },
          {
            type: "code",
            value:
              "let arr = [1, 2, 3];\narr.unshift(0);\nconsole.log(arr); // [0, 1, 2, 3]\n\nlet first = arr.shift();\nconsole.log(first); // 0\nconsole.log(arr); // [1, 2, 3]",
          },
        ],
      },
      {
        description: "concat vs. join",
        content: [
          {
            type: "text",
            value:
              "- `concat`: Merges arrays, returns a new array, does not mutate originals.",
          },
          {
            type: "text",
            value:
              "- `join`: Converts array to string with a separator, does not mutate the array.",
          },
          {
            type: "code",
            value:
              "let nums1 = [1, 2, 3], nums2 = [4, 5, 6];\nconsole.log(nums1.concat(nums2)); // [1, 2, 3, 4, 5, 6]\n\nconsole.log(nums1.join(\", \")); // '1, 2, 3'",
          },
        ],
      },
      {
        description: "includes vs. indexOf",
        content: [
          {
            type: "text",
            value:
              "- `includes`: Checks if an element exists, returns true/false.",
          },
          {
            type: "text",
            value:
              "- `indexOf`: Returns the index of an element, or -1 if not found.",
          },
          {
            type: "code",
            value:
              "let nums = [1, 2, 3];\nconsole.log(nums.includes(2)); // true\nconsole.log(nums.indexOf(2)); // 1",
          },
        ],
      },
      {
        description: "Object.keys vs. Object.values",
        content: [
          {
            type: "text",
            value: "- `Object.keys`: Returns an array of object keys.",
          },
          {
            type: "text",
            value: "- `Object.values`: Returns an array of object values.",
          },
          {
            type: "code",
            value:
              "let person = { name: 'John', age: 30 };\nconsole.log(Object.keys(person)); // ['name', 'age']\nconsole.log(Object.values(person)); // ['John', 30]",
          },
        ],
      },
      {
        description: "Object.assign vs. Spread Operator",
        content: [
          {
            type: "text",
            value: "- `Object.assign`: Merges objects, returns a new object.",
          },
          {
            type: "text",
            value:
              "- Spread Operator (`...`): Copies properties, shallow clones arrays/objects.",
          },
          {
            type: "code",
            value:
              "let obj1 = { name: 'John' }, obj2 = { age: 30 };\nlet merged = Object.assign({}, obj1, obj2);\nconsole.log(merged); // { name: 'John', age: 30 }\n\nlet copy = { ...obj1 };\nconsole.log(copy); // { name: 'John' }",
          },
        ],
      },
      {
        description: "What is the DOM?",
        content: [
          {
            type: "text",
            value:
              "The Document Object Model represents the structure of a web page as objects for scripting.",
          },
          {
            type: "code",
            value:
              "<!DOCTYPE html>\n<html>\n  <head><title>Document</title></head>\n  <body><h1>Hello World!</h1></body>\n</html>",
          },
        ],
      },
      {
        description: "How to select elements in the DOM?",
        content: [
          {
            type: "text",
            value: "- `getElementById`: Selects an element by ID.",
          },
          {
            type: "text",
            value:
              "- `getElementsByClassName`: Selects elements by class name.",
          },
          {
            type: "text",
            value: "- `getElementsByTagName`: Selects elements by tag name.",
          },
          {
            type: "text",
            value: "- `querySelector`: Selects the first matching element.",
          },
          {
            type: "text",
            value: "- `querySelectorAll`: Selects all matching elements.",
          },
          {
            type: "code",
            value:
              "let container = document.getElementById('container');\nlet paragraphs = document.getElementsByClassName('text');\nlet first = document.querySelector('.text');\nlet all = document.querySelectorAll('.text');",
          },
        ],
      },
      {
        description: "How to create elements in the DOM?",
        content: [
          {
            type: "text",
            value:
              "Use `document.createElement()` to create new elements dynamically.",
          },
          {
            type: "code",
            value:
              'let div = document.createElement("div");\ndiv.textContent = "Hello World!";\ndocument.body.appendChild(div);',
          },
        ],
      },
      {
        description: "How to add/remove classes in the DOM?",
        content: [
          {
            type: "text",
            value:
              "Use `element.classList.add()` to add and `element.classList.remove()` to remove classes.",
          },
          {
            type: "code",
            value:
              'let element = document.getElementById("container");\nelement.classList.add("active");\nelement.classList.remove("active");',
          },
        ],
      },
      {
        description: "How to add event listeners in the DOM?",
        content: [
          {
            type: "text",
            value:
              "Use `addEventListener()` to attach event handlers to elements.",
          },
          {
            type: "code",
            value:
              'let button = document.getElementById("button");\nbutton.addEventListener("click", () => console.log("Clicked!"));',
          },
        ],
      },
      {
        description: "What is local storage in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "Local Storage stores key-value pairs with no expiration date, surviving browser restarts.",
          },
          {
            type: "code",
            value:
              'localStorage.setItem("name", "John");\nconsole.log(localStorage.getItem("name")); // "John"',
          },
        ],
      },
      {
        description: "What is session storage in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "Session Storage stores key-value pairs but is cleared when the browser is closed.",
          },
          {
            type: "code",
            value:
              'sessionStorage.setItem("name", "John");\nconsole.log(sessionStorage.getItem("name")); // "John"',
          },
        ],
      },
      {
        description: "What is JSON?",
        content: [
          {
            type: "text",
            value:
              "JSON (JavaScript Object Notation) is a lightweight data format for exchanging structured data.",
          },
          {
            type: "code",
            value:
              'let person = { name: "John", age: 30 };\nlet json = JSON.stringify(person);\nconsole.log(json); // \'{"name":"John","age":30}\'\nlet obj = JSON.parse(json);\nconsole.log(obj.name); // "John"',
          },
        ],
      },
      {
        description: "What is a web API?",
        content: [
          {
            type: "text",
            value:
              "A Web API allows web applications to communicate with external services.",
          },
          {
            type: "code",
            value:
              'fetch("https://api.example.com/data")\n    .then(response => response.json())\n    .then(data => console.log(data));',
          },
        ],
      },
      {
        description: "What is CORS?",
        content: [
          {
            type: "text",
            value:
              "Cross-Origin Resource Sharing (CORS) enables secure resource sharing between different domains.",
          },
          {
            type: "code",
            value:
              "Access-Control-Allow-Origin: *\nAccess-Control-Allow-Methods: GET, POST\nAccess-Control-Allow-Headers: Content-Type",
          },
        ],
      },
      {
        description: "What is a cookie in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "A cookie is a small piece of data stored in the browser that can be used for authentication and tracking.",
          },
          {
            type: "code",
            value:
              'document.cookie = "name=John Doe; expires=Thu, 18 Dec 2023 12:00:00 UTC";',
          },
        ],
      },
      {
        description: "Difference between deep copy and shallow copy?",
        content: [
          {
            type: "text",
            value:
              "- **Shallow Copy**: Copies object references, so changes affect the original.\n- **Deep Copy**: Recursively copies all object properties, creating a completely independent copy.",
          },
          {
            type: "code",
            value:
              'let obj = { name: "John", address: { city: "New York" } };\nlet shallow = { ...obj };\nlet deep = JSON.parse(JSON.stringify(obj));\n\nobj.address.city = "Paris";\nconsole.log(shallow.address.city); // "Paris"\nconsole.log(deep.address.city); // "New York"',
          },
        ],
      },
      {
        description: "How does hasOwnProperty() work in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "The `hasOwnProperty()` method checks if an object has a direct property (not inherited).",
          },
          {
            type: "code",
            value:
              'let person = { name: "John" };\nconsole.log(person.hasOwnProperty("name")); // true\nconsole.log(person.hasOwnProperty("age")); // false',
          },
        ],
      },
      {
        description: "How do you prevent object mutation?",
        content: [
          {
            type: "text",
            value: "Use `Object.freeze()` to prevent changes to an object.",
          },
          {
            type: "code",
            value:
              'let person = { name: "John" };\nObject.freeze(person);\nperson.age = 30;\nconsole.log(person.age); // undefined',
          },
        ],
      },
      {
        description: "Difference between Object.freeze() and Object.seal()?",
        content: [
          {
            type: "text",
            value:
              "- **Object.freeze()**: Prevents adding, modifying, or removing properties.\n- **Object.seal()**: Prevents adding/removing properties but allows modifying existing ones.",
          },
          {
            type: "code",
            value:
              'let person = { name: "John" };\nObject.freeze(person);\nObject.seal(person);\nperson.age = 30;\nconsole.log(person.age); // undefined\n\nperson.name = "Doe";\nconsole.log(person.name); // "Doe"',
          },
        ],
      },
      {
        description: "How can you clone an object?",
        content: [
          {
            type: "text",
            value:
              "Use `Object.assign()` or the spread operator to create a copy of an object.",
          },
          {
            type: "code",
            value:
              'let obj = { name: "John" };\nlet clone = Object.assign({}, obj);\nlet copy = { ...obj };',
          },
        ],
      },
      {
        description: "What are different ways to create an array?",
        content: [
          {
            type: "text",
            value:
              "- **Array Literal**: `let arr = [1, 2, 3];`\n- **Array Constructor**: `let arr = new Array(1, 2, 3);`\n- **Array.from()**: `let arr = Array.from([1, 2, 3]);`",
          },
          {
            type: "code",
            value:
              "let arr1 = [1, 2, 3];\nlet arr2 = new Array(1, 2, 3);\nlet arr3 = Array.from([1, 2, 3]);",
          },
        ],
      },
      {
        description: "What is the difference between map and forEach?",
        content: [
          {
            type: "text",
            value:
              "- **map()**: Returns a new array with transformed elements.\n- **forEach()**: Iterates through elements but does not return a new array.",
          },
          {
            type: "code",
            value:
              "let numbers = [1, 2, 3];\nlet doubled = numbers.map(num => num * 2);\nnumbers.forEach(num => console.log(num));",
          },
        ],
      },
      {
        description: "What is the difference between find and filter?",
        content: [
          {
            type: "text",
            value:
              "- **find()**: Returns the first matching element.\n- **filter()**: Returns an array of all matching elements.",
          },
          {
            type: "code",
            value:
              "let numbers = [1, 2, 3, 4, 5];\nlet found = numbers.find(num => num % 2 === 0);\nlet even = numbers.filter(num => num % 2 === 0);",
          },
        ],
      },
      {
        description: "How can you remove duplicates from an array?",
        content: [
          {
            type: "text",
            value:
              "- **Using Set**: `let unique = [...new Set(array)];`\n- **Using filter**: `let unique = array.filter((item, index) => array.indexOf(item) === index);`",
          },
          {
            type: "code",
            value:
              "let numbers = [1, 2, 2, 3, 4, 4, 5];\nlet unique = [...new Set(numbers)];\nconsole.log(unique); // [1, 2, 3, 4, 5]",
          },
        ],
      },
      {
        description: "How can you flatten an array?",
        content: [
          {
            type: "text",
            value: "Use `flat()` to convert nested arrays into a single array.",
          },
          {
            type: "code",
            value:
              "let nested = [1, [2, 3], [4, [5]]];\nlet flat = nested.flat(Infinity);\nconsole.log(flat); // [1, 2, 3, 4, 5]",
          },
        ],
      },
      {
        description: "What is the event loop in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "The event loop manages asynchronous operations to ensure non-blocking execution.",
          },
          {
            type: "code",
            value:
              'console.log("Hello World!");\nsetTimeout(() => console.log("How are you?"), 1000);\nconsole.log("Goodbye!");',
          },
        ],
      },
      {
        description: "Difference between call stack and task queue?",
        content: [
          {
            type: "text",
            value:
              "- **Call Stack**: Executes synchronous code in LIFO order.\n- **Task Queue**: Stores asynchronous tasks in FIFO order.",
          },
          {
            type: "code",
            value:
              'console.log("Hello");\nsetTimeout(() => console.log("World"), 0);\nconsole.log("Goodbye");',
          },
        ],
      },
      {
        description: "Difference between microtask and macrotask?",
        content: [
          {
            type: "text",
            value:
              "- **Microtask**: Executes after the current task but before the next task.\n- **Macrotask**: Executes after the current and next tasks.",
          },
          {
            type: "code",
            value:
              'console.log("Hello");\nPromise.resolve().then(() => console.log("World"));\nconsole.log("Goodbye");',
          },
        ],
      },
      {
        description: "Difference between setTimeout and setInterval?",
        content: [
          {
            type: "text",
            value:
              "- **setTimeout**: Runs a function once after a delay.\n- **setInterval**: Runs a function repeatedly at a set interval.",
          },
          {
            type: "code",
            value:
              'setTimeout(() => console.log("Hello"), 1000);\nsetInterval(() => console.log("World"), 1000);',
          },
        ],
      },
      {
        description: "What is callback hell, and how can it be avoided?",
        content: [
          {
            type: "text",
            value:
              "Callback hell occurs when multiple nested callbacks make code unreadable.\n- **Avoid using inline callbacks**\n- **Use Promises or async/await**",
          },
          {
            type: "code",
            value:
              "// Callback Hell\nasyncFunc1(() => {\n    asyncFunc2(() => {\n        asyncFunc3(() => {\n            // More nested callbacks\n        });\n    });\n});\n\n// Avoiding Callback Hell with async/await\nasync function main() {\n    await asyncFunc1();\n    await asyncFunc2();\n    await asyncFunc3();\n}",
          },
        ],
      },
      {
        description: "What happens if you don't handle a rejected Promise?",
        content: [
          {
            type: "text",
            value:
              "An unhandled Promise rejection error occurs, which can crash the application in some environments.",
          },
        ],
      },
      {
        description:
          "Difference between Promise.all(), Promise.allSettled(), Promise.any(), and Promise.race()?",
        content: [
          {
            type: "text",
            value:
              "- **Promise.all()**: Resolves when all promises resolve, rejects if one fails.\n- **Promise.allSettled()**: Resolves after all promises are settled (resolved or rejected).\n- **Promise.any()**: Resolves when any promise resolves, ignores failures.\n- **Promise.race()**: Resolves/rejects with the first settled promise.",
          },
          {
            type: "code",
            value:
              'let promise1 = Promise.resolve(1);\nlet promise2 = Promise.reject("Error");\n\nPromise.all([promise1, promise2])\n    .then(values => console.log(values))\n    .catch(error => console.log(error));',
          },
        ],
      },
      {
        description:
          "Difference between async and defer attributes in a script tag?",
        content: [
          {
            type: "text",
            value:
              "- **async**: Downloads script asynchronously and executes when ready.\n- **defer**: Downloads script asynchronously but executes after parsing.",
          },
          {
            type: "code",
            value:
              '<script async src="script.js"></script>\n<script defer src="script.js"></script>',
          },
        ],
      },
      {
        description: "Difference between innerText and textContent?",
        content: [
          {
            type: "text",
            value:
              "- **innerText**: Returns only visible text (respects CSS styles).\n- **textContent**: Returns all text, even hidden.",
          },
          {
            type: "code",
            value:
              'let element = document.getElementById("container");\nconsole.log(element.innerText);\nconsole.log(element.textContent);',
          },
        ],
      },
      {
        description: "How do you create a delay function using Promises?",
        content: [
          {
            type: "text",
            value:
              "Use `setTimeout` within a Promise to create a delay function.",
          },
          {
            type: "code",
            value:
              'function delay(ms) {\n    return new Promise(resolve => setTimeout(resolve, ms));\n}\n\ndelay(1000).then(() => console.log("Hello World!"));',
          },
        ],
      },
      {
        description:
          "What is the difference between Bubbling and Capturing in event propagation?",
        content: [
          {
            type: "text",
            value:
              "- **Bubbling**: Events propagate from the target element to its parent elements.\n- **Capturing**: Events propagate from the parent elements down to the target.",
          },
          {
            type: "code",
            value:
              'let parent = document.getElementById("parent");\nlet child = document.getElementById("child");\n\nparent.addEventListener("click", () => console.log("Parent"));\nchild.addEventListener("click", () => console.log("Child"));',
          },
        ],
      },
      {
        description:
          "What is the difference between event.preventDefault() and event.stopPropagation()?",
        content: [
          {
            type: "text",
            value:
              "- **preventDefault()**: Prevents the default action of an event.\n- **stopPropagation()**: Stops the event from bubbling or capturing.",
          },
          {
            type: "code",
            value:
              'let link = document.getElementById("link");\nlink.addEventListener("click", event => {\n    event.preventDefault();\n    event.stopPropagation();\n});',
          },
        ],
      },
      {
        description: "What is the difference between try, catch, and finally?",
        content: [
          {
            type: "text",
            value:
              "- **try**: Contains code that might throw an error.\n- **catch**: Handles errors if they occur.\n- **finally**: Executes code after try/catch regardless of the outcome.",
          },
          {
            type: "code",
            value:
              'try {\n    throw new Error("Error!");\n} catch (error) {\n    console.log(error.message);\n} finally {\n    console.log("Execution completed");\n}',
          },
        ],
      },
      {
        description: "What is the difference between throw and return?",
        content: [
          {
            type: "text",
            value:
              "- **throw**: Throws an exception, stopping further execution.\n- **return**: Exits a function and optionally returns a value.",
          },
          {
            type: "code",
            value:
              'function divide(a, b) {\n    if (b === 0) {\n        throw new Error("Division by zero!");\n    }\n    return a / b;\n}',
          },
        ],
      },
      {
        description: "How do you handle asynchronous errors in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "Use try/catch with async/await or `.catch()` with Promises.",
          },
          {
            type: "code",
            value:
              'async function fetchData() {\n    try {\n        let response = await fetch("https://api.example.com/data");\n        let data = await response.json();\n        console.log(data);\n    } catch (error) {\n        console.log(error.message);\n    }\n}\n\nfetchData();',
          },
        ],
      },
      {
        description: "What is a custom error in JavaScript?",
        content: [
          {
            type: "text",
            value: "Custom errors are created by extending the `Error` class.",
          },
          {
            type: "code",
            value:
              'class ValidationError extends Error {\n    constructor(message) {\n        super(message);\n        this.name = "ValidationError";\n    }\n}\n\nthrow new ValidationError("Invalid input!");',
          },
        ],
      },
      {
        description: "What are ES6 modules?",
        content: [
          {
            type: "text",
            value:
              "ES6 modules allow code to be split into multiple files using `import` and `export`.",
          },
          {
            type: "code",
            value:
              '// File: utils.js\nexport function sum(a, b) {\n    return a + b;\n}\n\n// File: main.js\nimport { sum } from "./utils.js";\nconsole.log(sum(1, 2));',
          },
        ],
      },
      {
        description:
          "What is the difference between named and default exports?",
        content: [
          {
            type: "text",
            value:
              "- **Named Exports**: Export multiple values by name.\n- **Default Export**: Export a single value as the default.",
          },
          {
            type: "code",
            value:
              "// Named Exports\nexport function sum(a, b) {\n    return a + b;\n}\n\n// Default Export\nexport default function sum(a, b) {\n    return a + b;\n}",
          },
        ],
      },
      {
        description: "How do you use a module in Node.js?",
        content: [
          {
            type: "text",
            value: "Use `require()` to import CommonJS modules.",
          },
          {
            type: "code",
            value:
              '// File: utils.js\nmodule.exports = { sum: (a, b) => a + b };\n\n// File: main.js\nconst utils = require("./utils.js");\nconsole.log(utils.sum(1, 2));',
          },
        ],
      },
      {
        description: "What is the DOM in JavaScript?",
        content: [
          {
            type: "text",
            value:
              "The Document Object Model (DOM) represents the structure of a web page as objects for scripting.",
          },
        ],
      },
      {
        description: "How do you select elements in the DOM?",
        content: [
          {
            type: "text",
            value:
              "- **getElementById**: Selects an element by ID.\n- **getElementsByClassName**: Selects elements by class name.\n- **getElementsByTagName**: Selects elements by tag name.\n- **querySelector**: Selects the first matching element.\n- **querySelectorAll**: Selects all matching elements.",
          },
          {
            type: "code",
            value:
              'let container = document.getElementById("container");\nlet paragraphs = document.getElementsByClassName("text");\nlet first = document.querySelector(".text");\nlet all = document.querySelectorAll(".text");',
          },
        ],
      },
      {
        description: "How do you create elements in the DOM?",
        content: [
          {
            type: "text",
            value:
              "Use `document.createElement()` to create new elements dynamically.",
          },
          {
            type: "code",
            value:
              'let div = document.createElement("div");\ndiv.textContent = "Hello World!";\ndocument.body.appendChild(div);',
          },
        ],
      },
      {
        description: "What is event delegation?",
        content: [
          {
            type: "text",
            value:
              "Event delegation is a technique where a single event listener is used to handle events for multiple child elements.",
          },
          {
            type: "code",
            value:
              'let list = document.getElementById("list");\nlist.addEventListener("click", event => {\n    if (event.target.tagName === "LI") {\n        console.log(event.target.textContent);\n    }\n});',
          },
        ],
      },
      {
        description: "How do you manipulate the DOM using JavaScript?",
        content: [
          {
            type: "text",
            value:
              "- **Create elements**: `document.createElement()`\n- **Add elements**: `parent.appendChild(child)`\n- **Remove elements**: `parent.removeChild(child)`\n- **Replace elements**: `parent.replaceChild(new, old)`",
          },
          {
            type: "code",
            value:
              'let div = document.createElement("div");\ndiv.textContent = "Hello World!";\ndocument.body.appendChild(div);',
          },
        ],
      },
      {
        description: "How does lazy loading work?",
        content: [
          {
            type: "text",
            value:
              "Lazy loading defers loading non-essential resources until they are needed.",
          },
          {
            type: "code",
            value: '<img src="image.jpg" loading="lazy">',
          },
        ],
      },
      {
        description: "How can you improve JavaScript performance?",
        content: [
          {
            type: "text",
            value:
              "- Minimize DOM manipulation.\n- Use event delegation.\n- Optimize loops.\n- Avoid memory leaks.\n- Use efficient algorithms.",
          },
        ],
      },
      {
        description: "How do you prevent XSS (Cross-Site Scripting)?",
        content: [
          {
            type: "text",
            value:
              "Prevent XSS by sanitizing user input, escaping characters, and using Content Security Policy (CSP).",
          },
          {
            type: "code",
            value:
              'let userInput = "<script>alert(\'XSS\')</script>";\nlet sanitized = userInput.replace(/</g, "&lt;").replace(/>/g, "&gt;");\nconsole.log(sanitized); // "&lt;script&gt;alert(\'XSS\')&lt;/script&gt;"',
          },
        ],
      },
      {
        description: "How do you prevent CSRF (Cross-Site Request Forgery)?",
        content: [
          {
            type: "text",
            value:
              "Prevent CSRF by using CSRF tokens, checking the referrer, and using SameSite cookies.",
          },
          {
            type: "code",
            value:
              'let token = document.querySelector(\'meta[name="csrf-token"]\').content;\nfetch("https://api.example.com/data", {\n    method: "POST",\n    headers: {\n        "X-CSRF-Token": token\n    }\n});',
          },
        ],
      },
      {
        description: "What is Content Security Policy (CSP)?",
        content: [
          {
            type: "text",
            value:
              "Content Security Policy (CSP) is a security feature that helps prevent XSS attacks by restricting the sources from which scripts, styles, and other resources can be loaded.",
          },
        ],
      },
      {
        description: "How can you secure JavaScript code?",
        content: [
          {
            type: "text",
            value:
              "- Avoid using `eval()`.\n- Use strict mode (`'use strict'`).\n- Validate and sanitize user input.",
          },
        ],
      },
      {
        description: "How does JavaScript handle multithreading?",
        content: [
          {
            type: "text",
            value:
              "JavaScript is single-threaded but handles asynchronous operations using callbacks, Promises, and `async/await`.",
          },
        ],
      },
    ],
  },
  nodejs: {
    pages: [
      {
        "description": "What is Node.js, and how does it work?",
        "content": [
          {
            "type": "text",
            "value": "Node.js is an open-source, cross-platform **JavaScript runtime** built on Chrome's **V8 JavaScript engine**. It allows developers to execute JavaScript **outside the browser** and is designed for building scalable network applications using an **event-driven, non-blocking I/O model**."
          },
          {
            "type": "text",
            "value": "**How Node.js Works:**\n\n- **Single-threaded & Event-Driven**: Unlike traditional multi-threaded servers, Node.js uses a single thread to handle multiple client requests asynchronously.\n- **Non-blocking I/O**: Node.js delegates operations like database queries and file reading to the **libuv** library, freeing up the main thread.\n- **V8 Engine & JIT Compilation**: The V8 engine compiles JavaScript into optimized machine code for fast execution.\n- **Modules & npm**: Node.js provides a modular system, and `npm` helps manage dependencies efficiently."
          },
          {
            "type": "code",
            "value": "const http = require('http');\n\nconst server = http.createServer((req, res) => {\n    res.writeHead(200, { 'Content-Type': 'text/plain' });\n    res.end('Hello, Node.js!');\n});\n\nserver.listen(3000, () => {\n    console.log('Server running on http://localhost:3000');\n});"
          },
          {
            "type": "text",
            "value": "This simple **Node.js HTTP server** listens on **port 3000** and responds with `Hello, Node.js!` when accessed."
          },
          {
            "type": "text",
            "value": "**Key advantages of Node.js:**\n\n- ✔️ **Fast execution** using the V8 engine\n- ✔️ **Highly scalable** due to its event-driven model\n- ✔️ **Non-blocking asynchronous I/O** for efficiency\n- ✔️ **Full-stack JavaScript** (same language for frontend & backend)\n- ✔️ **Large ecosystem** with `npm` modules"
          }
        ]
      },
      {
        "description": "What are the key features of Node.js?",
        "content": [
          {
            "type": "text",
            "value": "Node.js is widely used for **backend development**, real-time applications, APIs, and microservices. Below are its key features:"
          },
          {
            "type": "text",
            "value": "**1. Asynchronous & Non-Blocking I/O**\n\n- **Node.js operates asynchronously**, meaning it doesn’t wait for tasks (e.g., database queries, file operations) to complete before moving on.\n- Uses an **event-driven architecture** to handle multiple requests efficiently."
          },
          {
            "type": "text",
            "value": "**2. Single-Threaded Event Loop**\n\n- Unlike traditional multi-threaded servers, Node.js runs on a **single thread** using an **event loop**.\n- This allows it to handle thousands of connections simultaneously **without blocking the main thread**."
          },
          {
            "type": "text",
            "value": "**3. Built on V8 JavaScript Engine**\n\n- The **V8 engine** compiles JavaScript into **machine code** for fast execution.\n- This results in **high performance and efficiency**, making Node.js suitable for large-scale applications."
          },
          {
            "type": "text",
            "value": "**4. Cross-Platform & Open-Source**\n\n- Node.js works on **Windows, macOS, and Linux**.\n- It's **open-source** and has a large, active community, making it well-supported and constantly improving."
          },
          {
            "type": "text",
            "value": "**5. Fast & Scalable**\n\n- The **event-driven, non-blocking model** ensures that Node.js can handle **high traffic loads**.\n- Ideal for building **real-time applications** like chat apps, gaming platforms, and streaming services."
          },
          {
            "type": "text",
            "value": "**6. Rich Ecosystem with npm**\n\n- The **Node Package Manager (npm)** provides access to thousands of **open-source libraries**.\n- Developers can install, manage, and share packages efficiently."
          },
          {
            "type": "text",
            "value": "**7. Supports Microservices & APIs**\n\n- Ideal for creating **RESTful APIs** and **GraphQL APIs**.\n- Works well with **microservices architecture**, enabling modular and maintainable applications."
          },
          {
            "type": "code",
            "value": "// Example: Simple Express.js server\nconst express = require('express');\nconst app = express();\n\napp.get('/', (req, res) => {\n    res.send('Welcome to Node.js!');\n});\n\napp.listen(3000, () => {\n    console.log('Server running on http://localhost:3000');\n});"
          },
          {
            "type": "text",
            "value": "This example demonstrates a **simple Express.js server** that responds with `Welcome to Node.js!` on the root route."
          }
        ]
      },
      {
        "description": "How is Node.js different from JavaScript in the browser?",
        "content": [
          {
            "type": "text",
            "value": "JavaScript is commonly used in web browsers for **frontend development**, while **Node.js** is a runtime that allows JavaScript to run outside the browser, primarily for **backend development**."
          },
          {
            "type": "text",
            "value": "**1. Execution Environment**\n\n- **Browser JavaScript** runs inside a web browser (Chrome, Firefox, Edge, etc.) and is executed by the browser's **JavaScript engine** (e.g., V8 for Chrome).\n- **Node.js** runs outside the browser using the **V8 engine**, but it also includes additional libraries for server-side operations."
          },
          {
            "type": "text",
            "value": "**2. Global Objects**\n\n- In the **browser**, global objects include `window`, `document`, `localStorage`, and `fetch`.\n- In **Node.js**, global objects include `global`, `process`, `require`, and `__dirname`."
          },
          {
            "type": "code",
            "value": "// Example: Accessing global objects\nconsole.log(window);  // Works in the browser, but not in Node.js\nconsole.log(global);  // Works in Node.js, but not in the browser"
          },
          {
            "type": "text",
            "value": "**3. Modules & Imports**\n\n- **Browser JavaScript** uses **ES Modules** (`import/export`).\n- **Node.js** traditionally used **CommonJS** (`require/module.exports`) but now supports ES Modules too."
          },
          {
            "type": "code",
            "value": "// Browser JavaScript (ES Modules)\nimport { myFunction } from './module.js';\nmyFunction();\n\n// Node.js (CommonJS)\nconst myModule = require('./module');\nmyModule.myFunction();"
          },
          {
            "type": "text",
            "value": "**4. File System & OS Access**\n\n- **Browser JavaScript** has **no access** to the file system or OS features for security reasons.\n- **Node.js** can read/write files, interact with the OS, and execute shell commands."
          },
          {
            "type": "code",
            "value": "// Node.js: Reading a file\nconst fs = require('fs');\nfs.readFile('example.txt', 'utf8', (err, data) => {\n    if (err) throw err;\n    console.log(data);\n});"
          },
          {
            "type": "text",
            "value": "**5. Event Handling**\n\n- **Browser JavaScript** uses **DOM events** (`onclick`, `addEventListener`).\n- **Node.js** has an `EventEmitter` module for custom event handling."
          },
          {
            "type": "code",
            "value": "// Node.js: EventEmitter example\nconst EventEmitter = require('events');\nconst event = new EventEmitter();\n\nevent.on('message', (msg) => {\n    console.log(`Received: ${msg}`);\n});\n\nevent.emit('message', 'Hello from Node.js');"
          },
          {
            "type": "text",
            "value": "**6. API Calls & Networking**\n\n- **Browser JavaScript** uses `fetch()` or `XMLHttpRequest` to make HTTP requests.\n- **Node.js** provides built-in modules like `http` and `https` to create and manage servers."
          },
          {
            "type": "code",
            "value": "// Browser JavaScript: Fetch API\nfetch('https://api.example.com/data')\n    .then(response => response.json())\n    .then(data => console.log(data));\n\n// Node.js: HTTP request\nconst https = require('https');\nhttps.get('https://api.example.com/data', (res) => {\n    let data = '';\n    res.on('data', chunk => data += chunk);\n    res.on('end', () => console.log(JSON.parse(data)));\n});"
          },
          {
            "type": "text",
            "value": "**Key Differences Summary:**\n\n- **Execution**: Browser (frontend) vs. Node.js (backend)\n- **Global Objects**: `window` vs. `global`\n- **Modules**: ES Modules (`import/export`) vs. CommonJS (`require`)\n- **File System Access**: Browser ❌ | Node.js ✅\n- **Networking**: `fetch()` vs. `http` module\n- **Event Handling**: DOM Events vs. `EventEmitter`"
          }
        ]
      },
      {
        "description": "What is the V8 engine, and how does it work in Node.js?",
        "content": [
          {
            "type": "text",
            "value": "The **V8 engine** is an open-source **JavaScript engine** developed by Google. It powers **Google Chrome** and **Node.js**, enabling fast execution of JavaScript code."
          },
          {
            "type": "text",
            "value": "**How does V8 work?**\n\n- **Compiles JavaScript to Machine Code**: Instead of interpreting JavaScript, V8 compiles it directly into **efficient machine code** using **Just-In-Time (JIT) compilation**.\n- **Uses Hidden Classes & Inline Caching**: V8 optimizes object property access by using **hidden classes** and **caching mechanisms**.\n- **Garbage Collection**: V8 automatically manages memory and removes unused objects using **generational garbage collection**."
          },
          {
            "type": "text",
            "value": "**V8 in Node.js**\n\n- In **browsers**, V8 runs JavaScript inside web pages.\n- In **Node.js**, V8 allows JavaScript to run outside the browser by interacting with the system using **Node.js APIs** (e.g., `fs`, `http`)."
          },
          {
            "type": "code",
            "value": "// Example: Running JavaScript in Node.js (powered by V8)\nconsole.log('Hello from Node.js!');"
          },
          {
            "type": "text",
            "value": "**Key Features of V8 in Node.js:**\n\n- **Fast Execution**: Converts JavaScript to **machine code** using JIT compilation.\n- **Memory Management**: Handles **automatic garbage collection**.\n- **Optimized Performance**: Uses **hidden classes** and **inline caching** to speed up execution.\n- **Standalone Execution**: Allows JavaScript to run outside the browser, enabling **server-side programming**."
          }
        ]
      },
      {
        "description": "Why is Node.js single-threaded, and how does it handle concurrency?",
        "content": [
          {
            "type": "text",
            "value": "Node.js is **single-threaded** to efficiently handle **asynchronous operations** using a non-blocking event-driven architecture. This design allows it to manage thousands of concurrent connections **without creating multiple threads** for each request."
          },
          {
            "type": "text",
            "value": "**Why is Node.js single-threaded?**\n\n- Uses a **single main thread** to avoid the overhead of thread creation and synchronization.\n- Built for **high-performance, scalable applications**, like web servers, real-time apps, and APIs.\n- Uses **asynchronous, non-blocking I/O** to handle multiple requests efficiently."
          },
          {
            "type": "text",
            "value": "**How does Node.js handle concurrency?**\n\nNode.js uses the **Event Loop** and **libuv** (a C++ library) to handle concurrency without blocking the main thread.\n\n1. **Event Loop**: A mechanism that continuously listens for and processes events.\n2. **Non-Blocking I/O**: Node.js delegates tasks like file reading, database queries, or network calls to the **system kernel or worker threads**, allowing other operations to proceed.\n3. **Worker Threads (Optional)**: For CPU-intensive tasks, Node.js provides a **Worker Threads module** to run tasks in parallel."
          },
          {
            "type": "code",
            "value": "// Example: Asynchronous Non-Blocking I/O\nconst fs = require('fs');\n\nconsole.log('Start');\nfs.readFile('file.txt', 'utf8', (err, data) => {\n    if (err) throw err;\n    console.log(data); // File reading happens asynchronously\n});\nconsole.log('End');"
          },
          {
            "type": "text",
            "value": "**Output Explanation:**\n\n1. `Start` is printed immediately.\n2. The `fs.readFile()` operation runs in the background.\n3. `End` is printed **before** the file is read.\n4. Once reading is complete, the callback function prints the file content."
          },
          {
            "type": "text",
            "value": "**Using Worker Threads for CPU-Intensive Tasks**\n\nFor CPU-heavy tasks (like processing large data sets), **Worker Threads** allow Node.js to run tasks in parallel without blocking the event loop."
          },
          {
            "type": "code",
            "value": "// Example: Using Worker Threads for Parallel Processing\nconst { Worker, isMainThread, parentPort } = require('worker_threads');\n\nif (isMainThread) {\n    const worker = new Worker(__filename);\n    worker.on('message', (msg) => console.log('Worker Output:', msg));\n} else {\n    parentPort.postMessage('Processing done!');\n}"
          },
          {
            "type": "text",
            "value": "**Summary:**\n\n- **Single-threaded event loop** for lightweight, fast, scalable applications.\n- **Handles I/O operations asynchronously** using callbacks, Promises, and async/await.\n- **Worker Threads** can be used for CPU-intensive tasks to avoid blocking the main thread."
          }
        ]
      },
      {
        "description": "What is the event loop in Node.js, and how does it work?",
        "content": [
          {
            "type": "text",
            "value": "The **event loop** is the core mechanism in **Node.js** that allows it to handle **asynchronous, non-blocking operations** efficiently on a **single thread**. It continuously listens for events and executes callbacks when tasks complete."
          },
          {
            "type": "text",
            "value": "**How does the event loop work?**\n\n1. **Call Stack**: Executes synchronous code first.\n2. **Node API / Worker Threads**: Asynchronous operations (I/O, timers, promises) are delegated to the system.\n3. **Callback Queue**: Once operations complete, their callbacks are added to the queue.\n4. **Event Loop Execution**: The event loop picks tasks from the queue and executes them."
          },
          {
            "type": "text",
            "value": "**Phases of the Event Loop:**\n\n1. **Timers** – Executes `setTimeout()` and `setInterval()` callbacks.\n2. **Pending Callbacks** – Handles system-level callbacks like TCP errors.\n3. **Idle, Prepare** – Internal operations.\n4. **Poll** – Handles I/O tasks (file reading, network requests, etc.).\n5. **Check** – Executes `setImmediate()` callbacks.\n6. **Close Callbacks** – Handles cleanup (e.g., closing connections)."
          },
          {
            "type": "code",
            "value": "// Example: Event Loop Execution Order\nconsole.log('Start');\n\nsetTimeout(() => {\n    console.log('setTimeout Callback');\n}, 0);\n\nsetImmediate(() => {\n    console.log('setImmediate Callback');\n});\n\nconsole.log('End');"
          },
          {
            "type": "text",
            "value": "**Expected Output:**\n\n1. `Start` and `End` execute first (synchronous code).\n2. **Event loop picks callbacks**:\n   - `setTimeout(0)` runs in the **Timers** phase.\n   - `setImmediate()` runs in the **Check** phase.\n3. The execution order of `setTimeout(0)` vs `setImmediate()` may vary depending on system conditions."
          },
          {
            "type": "text",
            "value": "**Handling Promises in the Event Loop**\n\n- Promises are handled in the **Microtask Queue**, which runs **before the next event loop iteration**."
          },
          {
            "type": "code",
            "value": "// Example: Promises vs. setTimeout\nconsole.log('Start');\n\nsetTimeout(() => console.log('Timeout Callback'), 0);\n\nPromise.resolve().then(() => console.log('Promise Callback'));\n\nconsole.log('End');"
          },
          {
            "type": "text",
            "value": "**Expected Output:**\n\n1. `Start`\n2. `End` (synchronous code finishes first)\n3. `Promise Callback` (Microtask Queue executes before next event loop cycle)\n4. `Timeout Callback` (from Timers phase)"
          },
          {
            "type": "text",
            "value": "**Key Takeaways:**\n\n- The **event loop** handles asynchronous tasks on a single thread.\n- Tasks are executed in phases: **Timers, I/O, Check, Close Callbacks**.\n- **Promises** run in the **Microtask Queue** before any next event loop cycle.\n- **setTimeout(0)** and **setImmediate()** may execute in different orders."
          }
        ]
      },
      {
        "description": "What is the difference between synchronous and asynchronous programming in Node.js?",
        "content": [
          {
            "type": "text",
            "value": "In **Node.js**, code execution can be either **synchronous (blocking)** or **asynchronous (non-blocking)**, depending on how operations are handled."
          },
          {
            "type": "text",
            "value": "**Synchronous (Blocking) Execution**\n\n- Executes **one task at a time** in sequence.\n- **Blocks** further execution until the current task is complete.\n- Slower when handling multiple tasks because it waits for each to finish before moving to the next."
          },
          {
            "type": "code",
            "value": "// Example: Synchronous (Blocking) Code\nconst fs = require('fs');\n\nconsole.log('Start');\nconst data = fs.readFileSync('file.txt', 'utf8'); // Blocks execution\nconsole.log(data);\nconsole.log('End');"
          },
          {
            "type": "text",
            "value": "**Expected Output:**\n\n1. `Start`\n2. File content is read and printed.\n3. `End` (Only runs **after** file reading is complete)."
          },
          {
            "type": "text",
            "value": "**Asynchronous (Non-Blocking) Execution**\n\n- **Does not block** execution; tasks run in the background.\n- Uses **callbacks, Promises, or async/await** to handle results.\n- Efficient for handling multiple tasks at once."
          },
          {
            "type": "code",
            "value": "// Example: Asynchronous (Non-Blocking) Code\nconst fs = require('fs');\n\nconsole.log('Start');\nfs.readFile('file.txt', 'utf8', (err, data) => {\n    if (err) throw err;\n    console.log(data); // Runs later when file reading is complete\n});\nconsole.log('End');"
          },
          {
            "type": "text",
            "value": "**Expected Output:**\n\n1. `Start`\n2. `End` (printed before file reading completes)\n3. File content is printed after reading is done."
          },
          {
            "type": "text",
            "value": "**Key Differences:**\n\n| Feature            | Synchronous (Blocking) | Asynchronous (Non-Blocking) |\n|-------------------|----------------------|---------------------------|\n| Execution Order   | One task at a time    | Multiple tasks run concurrently |\n| Performance      | Slower for I/O        | Faster, handles multiple requests |\n| Use Cases        | Small scripts, sequential operations | Web servers, real-time apps, API calls |\n| Example Methods  | `fs.readFileSync()`   | `fs.readFile()` with callback, Promises, async/await |\n"
          },
          {
            "type": "text",
            "value": "**When to Use Asynchronous Code?**\n\n- When handling **I/O operations** (file system, databases, APIs).\n- In **web servers** to handle multiple requests efficiently.\n- For **real-time applications** (chats, live notifications)."
          }
        ]
      },
      {
        "description": "What are CommonJS and ES6 modules in Node.js?",
        "content": [
          {
            "type": "text",
            "value": "Node.js supports **two module systems**: **CommonJS (CJS)** and **ES6 Modules (ESM)**. They define how code is structured, imported, and exported."
          },
          {
            "type": "text",
            "value": "**CommonJS (CJS) Modules**\n\n- The **default module system** in Node.js.\n- Uses `require()` to import modules.\n- Uses `module.exports` or `exports` to export values.\n- Synchronous loading (better for server-side usage)."
          },
          {
            "type": "code",
            "value": "// Example: CommonJS Module (math.js)\nmodule.exports.add = (a, b) => a + b;\nmodule.exports.subtract = (a, b) => a - b;\n\n// Importing in another file\nconst math = require('./math');\nconsole.log(math.add(2, 3)); // Output: 5"
          },
          {
            "type": "text",
            "value": "**ES6 (ECMAScript) Modules**\n\n- Uses `import` and `export` statements.\n- Asynchronous loading (better for client-side and modern Node.js apps).\n- Requires `\"type\": \"module\"` in `package.json` or `.mjs` file extension."
          },
          {
            "type": "code",
            "value": "// Example: ES6 Module (math.mjs)\nexport const add = (a, b) => a + b;\nexport const subtract = (a, b) => a - b;\n\n// Importing in another file\nimport { add } from './math.mjs';\nconsole.log(add(2, 3)); // Output: 5"
          },
          {
            "type": "text",
            "value": "**Key Differences Between CommonJS and ES6 Modules**\n\n| Feature            | CommonJS (CJS)        | ES6 Modules (ESM)       |\n|-------------------|---------------------|----------------------|\n| Syntax           | `require()` / `module.exports` | `import` / `export` |\n| Execution        | Synchronous (Blocking) | Asynchronous (Non-blocking) |\n| File Extension   | `.js`                 | `.mjs` or `\"type\": \"module\"` in `package.json` |\n| Default Support  | Yes (built-in for Node.js) | Requires `\"type\": \"module\"` in `package.json` |\n| Suitable For     | Backend, server-side apps | Modern frontend and backend apps |"
          },
          {
            "type": "text",
            "value": "**When to Use Each?**\n\n- Use **CommonJS** when working with **older Node.js projects** or packages that rely on synchronous imports.\n- Use **ES6 Modules** for **modern JavaScript projects**, **TypeScript**, or when working with tools like Webpack, Babel, and frontend frameworks."
          }
        ]
      },
      {
        "description": "How do you import and export modules in Node.js?",
        "content": [
          {
            "type": "text",
            "value": "In **Node.js**, modules allow you to organize and reuse code. There are two ways to import and export modules: **CommonJS (CJS)** and **ES6 Modules (ESM).**"
          },
          {
            "type": "text",
            "value": "**1. Using CommonJS (CJS) Modules**\n\n- Default module system in Node.js.\n- Uses `require()` to import modules.\n- Uses `module.exports` or `exports` to export values.\n- Best for traditional Node.js applications."
          },
          {
            "type": "code",
            "value": "// Exporting in CommonJS (math.js)\nmodule.exports.add = (a, b) => a + b;\nmodule.exports.subtract = (a, b) => a - b;\n\n// OR shorthand\nexports.multiply = (a, b) => a * b;"
          },
          {
            "type": "code",
            "value": "// Importing in CommonJS (app.js)\nconst math = require('./math');\nconsole.log(math.add(2, 3)); // Output: 5\nconsole.log(math.multiply(2, 3)); // Output: 6"
          },
          {
            "type": "text",
            "value": "**2. Using ES6 (ECMAScript) Modules**\n\n- Uses `import` and `export` statements.\n- Requires `\"type\": \"module\"` in `package.json` or `.mjs` extension.\n- Supports **named exports** and **default exports**."
          },
          {
            "type": "code",
            "value": "// Named Export in ES6 (math.mjs)\nexport const add = (a, b) => a + b;\nexport const subtract = (a, b) => a - b;"
          },
          {
            "type": "code",
            "value": "// Importing Named Exports in ES6 (app.mjs)\nimport { add, subtract } from './math.mjs';\nconsole.log(add(2, 3)); // Output: 5"
          },
          {
            "type": "code",
            "value": "// Default Export in ES6 (math.mjs)\nconst divide = (a, b) => a / b;\nexport default divide;"
          },
          {
            "type": "code",
            "value": "// Importing Default Export in ES6 (app.mjs)\nimport divide from './math.mjs';\nconsole.log(divide(6, 2)); // Output: 3"
          },
          {
            "type": "text",
            "value": "**Key Differences Between CommonJS and ES6 Modules**\n\n| Feature           | CommonJS (CJS)         | ES6 Modules (ESM) |\n|------------------|----------------------|------------------|\n| Syntax           | `require()` / `module.exports` | `import` / `export` |\n| Default in Node.js | Yes                   | Requires `\"type\": \"module\"` or `.mjs` |\n| Execution        | Synchronous (Blocking) | Asynchronous (Non-blocking) |\n| File Extension   | `.js`                   | `.mjs` or `\"type\": \"module\"` |\n| Suitable For     | Server-side Node.js apps | Modern JavaScript, frontend & backend |"
          },
          {
            "type": "text",
            "value": "**When to Use Each?**\n\n- Use **CommonJS** if working with **older Node.js projects** or **existing npm packages** that rely on `require()`.\n- Use **ES6 Modules** for **modern projects**, **TypeScript**, or if using **import/export** in both frontend and backend."
          }
        ]
      },
      {
        "description": "What is package.json, and why is it important?",
        "content": [
          {
            "type": "text",
            "value": "`package.json` is a **configuration file** in a Node.js project that stores metadata about the project, its dependencies, scripts, and other settings. It acts as the central **manifest file** for any Node.js application or package."
          },
          {
            "type": "text",
            "value": "**Why is `package.json` important?**\n\n- **Manages dependencies**: Lists all required packages and their versions.\n- **Defines project metadata**: Includes the project name, version, description, and author.\n- **Automates scripts**: Allows custom scripts (e.g., start, test, build) for automation.\n- **Ensures compatibility**: Helps maintain consistent versions across different environments.\n- **Facilitates sharing**: Required when publishing a package to npm."
          },
          {
            "type": "code",
            "value": "// Example: Basic package.json\n{\n  \"name\": \"my-app\",\n  \"version\": \"1.0.0\",\n  \"description\": \"A sample Node.js project\",\n  \"main\": \"index.js\",\n  \"scripts\": {\n    \"start\": \"node index.js\",\n    \"test\": \"echo \\\"No tests defined\\\" && exit 1\"\n  },\n  \"dependencies\": {\n    \"express\": \"^4.18.2\"\n  },\n  \"devDependencies\": {\n    \"nodemon\": \"^3.0.0\"\n  },\n  \"author\": \"John Doe\",\n  \"license\": \"MIT\"\n}"
          },
          {
            "type": "text",
            "value": "**Key Fields in package.json**\n\n| Field            | Description |\n|-----------------|-------------|\n| `name`          | Name of the project/package |\n| `version`       | Current version of the project |\n| `description`   | Short explanation of the project |\n| `main`          | Entry point file (e.g., `index.js`) |\n| `scripts`       | Custom commands (e.g., start, test) |\n| `dependencies`  | List of required packages for production |\n| `devDependencies` | Packages needed only for development |\n| `author`        | Name of the project creator |\n| `license`       | Specifies licensing information |"
          },
          {
            "type": "text",
            "value": "**Common Commands Using package.json**\n\n- **Initialize a new project**: `npm init -y` (creates a default `package.json`).\n- **Install dependencies**: `npm install express` (adds to `dependencies`).\n- **Install dev dependencies**: `npm install nodemon --save-dev` (adds to `devDependencies`).\n- **Run scripts**: `npm start` (runs the script defined under `scripts.start`)."
          },
          {
            "type": "text",
            "value": "**Why is it crucial?**\n\n- **Keeps project dependencies organized**.\n- **Automates tasks like starting the server or running tests**.\n- **Ensures consistency when sharing or deploying projects**.\n- **Required for publishing npm packages**."
          }
        ]
      },
      {
        "description": "What is the difference between dependencies, devDependencies, and peerDependencies?",
        "content": [
          {
            "type": "text",
            "value": "In **package.json**, dependencies are categorized into three types: **dependencies**, **devDependencies**, and **peerDependencies**. Each serves a different purpose in a Node.js project."
          },
          {
            "type": "text",
            "value": "**1. Dependencies (`dependencies`)**\n\n- These are the packages **required for the application to run** in production.\n- Installed using `npm install <package-name>`.\n- Listed in `package.json` under the `dependencies` section.\n- Included when running `npm install` in a new environment."
          },
          {
            "type": "code",
            "value": "// Example: Dependencies in package.json\n{\n  \"dependencies\": {\n    \"express\": \"^4.18.2\",\n    \"mongoose\": \"^7.0.0\"\n  }\n}"
          },
          {
            "type": "text",
            "value": "**2. DevDependencies (`devDependencies`)**\n\n- These are packages **only needed during development** (e.g., testing, linting, build tools).\n- Installed using `npm install <package-name> --save-dev`.\n- Listed in `package.json` under the `devDependencies` section.\n- Not included when running `npm install --production`."
          },
          {
            "type": "code",
            "value": "// Example: DevDependencies in package.json\n{\n  \"devDependencies\": {\n    \"nodemon\": \"^3.0.0\",\n    \"eslint\": \"^8.0.0\"\n  }\n}"
          },
          {
            "type": "text",
            "value": "**3. PeerDependencies (`peerDependencies`)**\n\n- These are packages that **the project expects the user to provide**.\n- Used for libraries/plugins that need a specific version of a package.\n- Installed manually by the user of the package.\n- Defined in `package.json` under `peerDependencies`."
          },
          {
            "type": "code",
            "value": "// Example: PeerDependencies in package.json\n{\n  \"peerDependencies\": {\n    \"react\": \"^18.0.0\"\n  }\n}"
          },
          {
            "type": "text",
            "value": "**Key Differences**\n\n| Type               | Used For             | Installed By Default? | Example Packages |\n|--------------------|---------------------|--------------------|-----------------|\n| `dependencies`    | Required in production | ✅ Yes | `express`, `mongoose` |\n| `devDependencies` | Used only in development | ❌ No | `nodemon`, `jest` |\n| `peerDependencies` | Expected to be installed by user | ❌ No | `react`, `webpack` |\n"
          },
          {
            "type": "text",
            "value": "**When to Use Each?**\n\n- **Use `dependencies`** for packages that your app needs to run (e.g., `express`, `mongoose`).\n- **Use `devDependencies`** for development tools (e.g., `nodemon`, `eslint`).\n- **Use `peerDependencies`** when developing libraries/plugins that require the user to install a specific package (e.g., `react` in a React library)."
          }
        ]
      },
      {
        description: "What is NPX, and how does it differ from NPM?",
        content: [
          {
            type: "text",
            value:
              "NPX is a package runner that allows executing Node.js packages without installing them globally. Unlike NPM, which installs packages, NPX runs them directly.",
          },
          {
            type: "code",
            value:
              "// Example: Running create-react-app without installing\nnpx create-react-app my-app",
          },
        ],
      },
      {
        description: "How do you read and write files in Node.js?",
        content: [
          {
            type: "text",
            value: "Use the `fs` module in Node.js to read and write files.",
          },
          {
            type: "code",
            value:
              "// Reading a file\nconst fs = require('fs');\nfs.readFile('file.txt', 'utf8', (err, data) => {\n    console.log(data);\n});\n\n// Writing to a file\nfs.writeFile('file.txt', 'Hello, Node.js!', err => {\n    if (err) throw err;\n});",
          },
        ],
      },
      {
        description:
          "What is the difference between fs.readFile() and fs.createReadStream()?",
        content: [
          {
            type: "text",
            value:
              "- **fs.readFile()**: Reads the entire file into memory, useful for small files.\n- **fs.createReadStream()**: Reads data in chunks, useful for large files.",
          },
          {
            type: "code",
            value:
              "// Using fs.readFile()\nfs.readFile('file.txt', 'utf8', (err, data) => console.log(data));\n\n// Using fs.createReadStream()\nfs.createReadStream('file.txt').on('data', chunk => console.log(chunk.toString()));",
          },
        ],
      },
      {
        description: "What are streams in Node.js, and what are their types?",
        content: [
          {
            type: "text",
            value:
              "Streams are used to handle large amounts of data efficiently. Types of streams:\n- **Readable**: Read data (e.g., `fs.createReadStream`).\n- **Writable**: Write data (e.g., `fs.createWriteStream`).\n- **Duplex**: Read and write data (e.g., sockets).\n- **Transform**: Modify data (e.g., compression).",
          },
        ],
      },
      {
        description: "How do you handle large files efficiently in Node.js?",
        content: [
          {
            type: "text",
            value:
              "Use streams to process large files without loading them into memory.",
          },
          {
            type: "code",
            value:
              "// Efficiently reading a large file\nconst fs = require('fs');\nfs.createReadStream('largeFile.txt')\n  .on('data', chunk => console.log('Processing chunk...'))\n  .on('end', () => console.log('Done processing file'));",
          },
        ],
      },
      {
        description:
          "What is the EventEmitter in Node.js, and how does it work?",
        content: [
          {
            type: "text",
            value:
              "EventEmitter is a built-in module in Node.js that allows handling custom events asynchronously.",
          },
          {
            type: "code",
            value:
              "const EventEmitter = require('events');\nconst emitter = new EventEmitter();\nemitter.on('message', msg => console.log(msg));\nemitter.emit('message', 'Hello EventEmitter!');",
          },
        ],
      },
      {
        description: "How do you create and use custom events in Node.js?",
        content: [
          {
            type: "text",
            value: "Use the `events` module to create and emit custom events.",
          },
          {
            type: "code",
            value:
              "const EventEmitter = require('events');\nclass MyEmitter extends EventEmitter {}\nconst myEmitter = new MyEmitter();\nmyEmitter.on('greet', () => console.log('Hello!'));\nmyEmitter.emit('greet');",
          },
        ],
      },
      {
        description:
          "What is the difference between process.nextTick() and setImmediate()?",
        content: [
          {
            type: "text",
            value:
              "- **process.nextTick()**: Executes callbacks immediately after the current operation, before I/O events.\n- **setImmediate()**: Executes callbacks after I/O events, in the next event loop iteration.",
          },
          {
            type: "code",
            value:
              "console.log('Start');\nprocess.nextTick(() => console.log('nextTick'));\nsetImmediate(() => console.log('setImmediate'));\nconsole.log('End');",
          },
        ],
      },
      {
        description: "How do you create a simple HTTP server in Node.js?",
        content: [
          {
            type: "text",
            value:
              "Use the built-in `http` module to create a simple HTTP server in Node.js.",
          },
          {
            type: "code",
            value:
              "const http = require('http');\nconst server = http.createServer((req, res) => {\n  res.writeHead(200, { 'Content-Type': 'text/plain' });\n  res.end('Hello, World!');\n});\nserver.listen(3000, () => console.log('Server running on port 3000'));",
          },
        ],
      },
      {
        description:
          "What is the difference between microtasks and macrotasks in Node.js?",
        content: [
          {
            type: "text",
            value:
              "In Node.js, the event loop handles asynchronous operations by scheduling them as either **microtasks** or **macrotasks**. Microtasks have higher priority and execute before macrotasks.",
          },
          {
            type: "text",
            value:
              "**Microtasks:**\n- Executed **immediately after the current synchronous code** but before macrotasks.\n- Used for **high-priority tasks** that should execute as soon as possible.\n- Examples: `process.nextTick()`, Promises (`Promise.then()`).",
          },
          {
            type: "text",
            value:
              "**Macrotasks:**\n- Scheduled in the **event loop phases** and executed in the next available cycle.\n- Used for **timers, I/O operations, and deferred execution**.\n- Examples: `setTimeout()`, `setImmediate()`, I/O tasks.",
          },
          {
            type: "code",
            value:
              "console.log('1. Start');\n\nsetTimeout(() => {\n  console.log('2. setTimeout (Macrotask)');\n}, 0);\n\nsetImmediate(() => {\n  console.log('3. setImmediate (Macrotask)');\n});\n\nprocess.nextTick(() => {\n  console.log('4. process.nextTick (Microtask)');\n});\n\nPromise.resolve().then(() => {\n  console.log('5. Promise.then (Microtask)');\n});\n\nconsole.log('6. End');",
          },
          {
            type: "text",
            value:
              "**Expected Output:**\n```\n1. Start\n6. End\n4. process.nextTick (Microtask)\n5. Promise.then (Microtask)\n3. setImmediate (Macrotask)\n2. setTimeout (Macrotask)\n```",
          },
          {
            type: "text",
            value:
              "**Execution Flow Explanation:**\n1. **Synchronous code executes first** → `1. Start`, `6. End`.\n2. **Microtasks execute next (highest priority)** → `4. process.nextTick`, `5. Promise.then`.\n3. **Macrotasks execute in the next event loop cycle**:\n   - `setImmediate()` runs first because timers (`setTimeout`) are delayed slightly.\n   - `setTimeout()` runs last since it's scheduled in the timer phase.",
          },
        ],
      },
      {
        description: "What are middlewares in Express.js?",
        content: [
          {
            type: "text",
            value:
              "Middlewares are functions in Express.js that process requests before reaching the final route handler.",
          },
          {
            type: "code",
            value:
              "app.use((req, res, next) => {\n  console.log('Request received');\n  next();\n});",
          },
        ],
      },
      {
        description: "What is the difference between app.use() and app.get()?",
        content: [
          {
            type: "text",
            value:
              "- `app.use()`: Used for middleware that applies to all routes.\n- `app.get()`: Handles only GET requests for a specific route.",
          },
          {
            type: "code",
            value:
              "app.use((req, res, next) => console.log('Middleware executed'));\napp.get('/', (req, res) => res.send('Hello, World!'));",
          },
        ],
      },
      {
        description: "How do you handle errors in Express.js?",
        content: [
          {
            type: "text",
            value:
              "Use error-handling middleware by passing `err` as the first parameter.",
          },
          {
            type: "code",
            value:
              "app.use((err, req, res, next) => {\n  console.error(err.message);\n  res.status(500).send('Server Error');\n});",
          },
        ],
      },
      {
        description: "What are callbacks, and what is callback hell?",
        content: [
          {
            type: "text",
            value:
              "Callbacks are functions passed as arguments to handle asynchronous operations. Callback hell occurs when multiple nested callbacks make code hard to read.",
          },
          {
            type: "code",
            value:
              "fs.readFile('file.txt', (err, data) => {\n  if (err) return console.error(err);\n  console.log(data);\n});",
          },
        ],
      },
      {
        description: "What are Promises, and how do they work?",
        content: [
          {
            type: "text",
            value:
              "Promises handle asynchronous operations and avoid callback hell using `.then()` and `.catch()`.",
          },
          {
            type: "code",
            value:
              "new Promise((resolve, reject) => {\n  setTimeout(() => resolve('Done!'), 1000);\n}).then(console.log);",
          },
        ],
      },
      {
        description:
          "What is async/await, and how is it different from Promises?",
        content: [
          {
            type: "text",
            value:
              "`async/await` simplifies handling Promises by making code look synchronous.",
          },
          {
            type: "code",
            value:
              "async function fetchData() {\n  let response = await fetch('https://api.example.com/data');\n  let data = await response.json();\n  console.log(data);\n}",
          },
        ],
      },
      {
        description:
          "What is the difference between Promise.all() and Promise.race()?",
        content: [
          {
            type: "text",
            value:
              "- `Promise.all()`: Waits for all promises to resolve.\n- `Promise.race()`: Resolves as soon as the first promise resolves.",
          },
          {
            type: "code",
            value:
              "Promise.all([promise1, promise2]).then(console.log);\nPromise.race([promise1, promise2]).then(console.log);",
          },
        ],
      },
      {
        description: "How do you connect Node.js with MongoDB?",
        content: [
          {
            type: "text",
            value:
              "Use the `mongodb` or `mongoose` package to connect Node.js to MongoDB.",
          },
          {
            type: "code",
            value:
              "const mongoose = require('mongoose');\nmongoose.connect('mongodb://localhost:27017/mydb', { useNewUrlParser: true, useUnifiedTopology: true });",
          },
        ],
      },
      {
        description: "What is Mongoose, and why is it used?",
        content: [
          {
            type: "text",
            value:
              "Mongoose is an ODM (Object Data Modeling) library for MongoDB in Node.js.",
          },
        ],
      },
      {
        description: "What is the difference between SQL and NoSQL databases?",
        content: [
          {
            type: "text",
            value:
              "- **SQL**: Structured, uses tables and schemas.\n- **NoSQL**: Flexible, uses key-value, document, or graph storage.",
          },
        ],
      },
      {
        description:
          "How do you handle transactions in MySQL or MongoDB using Node.js?",
        content: [
          {
            type: "text",
            value: "Use transactions to ensure data consistency in databases.",
          },
          {
            type: "code",
            value:
              "// MongoDB Transaction\nconst session = await mongoose.startSession();\nsession.startTransaction();\ntry {\n  await User.create([{ name: 'John' }], { session });\n  await session.commitTransaction();\n} catch (err) {\n  await session.abortTransaction();\n}",
          },
        ],
      },
      {
        description: "What is JWT, and how does it work?",
        content: [
          {
            type: "text",
            value:
              "JWT (JSON Web Token) is used for authentication by encoding user data into a token.",
          },
          {
            type: "code",
            value:
              "const jwt = require('jsonwebtoken');\nconst token = jwt.sign({ userId: 123 }, 'secret', { expiresIn: '1h' });",
          },
        ],
      },
      {
        description: "How do you store passwords securely in Node.js?",
        content: [
          {
            type: "text",
            value:
              "Use `bcrypt` to hash passwords before storing them in a database.",
          },
          {
            type: "code",
            value:
              "const bcrypt = require('bcrypt');\nconst hashedPassword = await bcrypt.hash('password123', 10);",
          },
        ],
      },
      {
        description: "What is the purpose of bcrypt in authentication?",
        content: [
          {
            type: "text",
            value:
              "`bcrypt` is used to hash passwords securely and compare them during login.",
          },
        ],
      },
      {
        description: "How do you prevent SQL injection in Node.js?",
        content: [
          {
            type: "text",
            value: "Use parameterized queries to prevent SQL injection.",
          },
          {
            type: "code",
            value:
              "const db = require('mysql');\ndb.query('SELECT * FROM users WHERE username = ?', [username], (err, results) => {\n  console.log(results);\n});",
          },
        ],
      },
      {
        description:
          "What is clustering in Node.js, and how does it improve performance?",
        content: [
          {
            type: "text",
            value:
              "Clustering allows Node.js to utilize multiple CPU cores by creating worker processes that share the same server port.",
          },
          {
            type: "code",
            value:
              "const cluster = require('cluster');\nconst http = require('http');\nconst os = require('os');\nif (cluster.isMaster) {\n  os.cpus().forEach(() => cluster.fork());\n} else {\n  http.createServer((req, res) => res.end('Hello')).listen(3000);\n}",
          },
        ],
      },
      {
        description:
          "How do you use caching to improve performance in Node.js?",
        content: [
          {
            type: "text",
            value:
              "Caching stores frequently accessed data to reduce load time and database queries.",
          },
          {
            type: "code",
            value:
              "const cache = new Map();\nfunction getData(key) {\n  if (cache.has(key)) return cache.get(key);\n  let data = fetchFromDatabase(key);\n  cache.set(key, data);\n  return data;\n}",
          },
        ],
      },
      {
        description: "What is Redis, and how does it work with Node.js?",
        content: [
          {
            type: "text",
            value:
              "Redis is an in-memory key-value store used for caching, session storage, and real-time applications in Node.js.",
          },
          {
            type: "code",
            value:
              "const redis = require('redis');\nconst client = redis.createClient();\nclient.set('key', 'value');\nclient.get('key', (err, reply) => console.log(reply));",
          },
        ],
      },
      {
        description:
          "How do you monitor the performance of a Node.js application?",
        content: [
          {
            type: "text",
            value:
              "Use monitoring tools like `pm2`, `New Relic`, or `node --inspect` for profiling.",
          },
        ],
      },
      {
        description:
          "What are the different testing frameworks available for Node.js?",
        content: [
          {
            type: "text",
            value:
              "Popular testing frameworks include Jest, Mocha, Chai, and Jasmine.",
          },
        ],
      },
      {
        description: "What is Jest, and how is it used for testing?",
        content: [
          {
            type: "text",
            value:
              "Jest is a JavaScript testing framework used for unit and integration testing.",
          },
          {
            type: "code",
            value:
              "test('adds 1 + 2 to equal 3', () => {\n  expect(1 + 2).toBe(3);\n});",
          },
        ],
      },
      {
        description: "How do you perform API testing in Node.js?",
        content: [
          {
            type: "text",
            value:
              "Use tools like Postman or frameworks like Jest and Supertest for API testing.",
          },
          {
            type: "code",
            value:
              "const request = require('supertest');\ntest('GET /', async () => {\n  const res = await request(app).get('/');\n  expect(res.statusCode).toBe(200);\n});",
          },
        ],
      },
      {
        description:
          "What is the difference between unit tests and integration tests?",
        content: [
          {
            type: "text",
            value:
              "- **Unit Tests**: Test individual functions.\n- **Integration Tests**: Test multiple modules working together.",
          },
        ],
      },
      {
        description: "What are worker threads in Node.js?",
        content: [
          {
            type: "text",
            value:
              "Worker threads allow parallel execution of JavaScript code in Node.js.",
          },
          {
            type: "code",
            value:
              "const { Worker } = require('worker_threads');\nconst worker = new Worker('./worker.js');",
          },
        ],
      },
      {
        description:
          "What is the difference between microtasks and macrotasks in Node.js?",
        content: [
          {
            type: "text",
            value:
              "- **Microtasks**: Executed before macrotasks (e.g., `process.nextTick`, Promises).\n- **Macrotasks**: Scheduled in the event loop (e.g., `setTimeout`, `setImmediate`).",
          },
        ],
      },
      {
        description: "How does Node.js handle memory management?",
        content: [
          {
            type: "text",
            value:
              "Node.js uses the V8 garbage collector to automatically manage memory allocation and deallocation.",
          },
        ],
      },
      {
        description: "What is WebSockets, and how do you use them in Node.js?",
        content: [
          {
            type: "text",
            value:
              "WebSockets allow real-time, bidirectional communication between the server and client.",
          },
          {
            type: "code",
            value:
              "const WebSocket = require('ws');\nconst wss = new WebSocket.Server({ port: 8080 });\nwss.on('connection', ws => ws.send('Hello, WebSocket!'));",
          },
        ],
      },
      {
        description:
          "What is the difference between fork, spawn, and exec in Node.js?",
        content: [
          {
            type: "text",
            value:
              "- **fork**: Creates a new Node.js process that shares communication with the parent.\n- **spawn**: Executes a new process with streams.\n- **exec**: Executes a shell command and buffers output.",
          },
        ],
      },
      {
        description: "How do you deploy a Node.js application in production?",
        content: [
          {
            type: "text",
            value:
              "Use PM2, Docker, or cloud services like AWS, Heroku, or DigitalOcean.",
          },
          {
            type: "code",
            value: "pm2 start app.js",
          },
        ],
      },
    ],
  },
  typescript: {
    pages: [],
  },
  database: {
    pages: [
      {
        description: "What is MySQL, and why is it used?",
        content: [
          {
            type: "text",
            value:
              "MySQL is an open-source relational database management system (RDBMS) used for storing, managing, and retrieving structured data efficiently.",
          },
        ],
      },
      {
        description:
          "What are the differences between SQL and NoSQL databases?",
        content: [
          {
            type: "text",
            value:
              "- **SQL**: Structured, uses tables, enforces schema (e.g., MySQL, PostgreSQL).\n- **NoSQL**: Schema-less, stores data in JSON, key-value, or graph format (e.g., MongoDB).",
          },
        ],
      },
      {
        description: "What are the ACID properties in MySQL?",
        content: [
          {
            type: "text",
            value:
              "ACID (Atomicity, Consistency, Isolation, Durability) ensures reliable transactions in MySQL.",
          },
        ],
      },
      {
        description: "What is a primary key, and why is it important?",
        content: [
          {
            type: "text",
            value:
              "A primary key uniquely identifies each row in a table and ensures data integrity.",
          },
        ],
      },
      {
        description: "What is a foreign key, and how does it work?",
        content: [
          {
            type: "text",
            value:
              "A foreign key links one table to another, enforcing referential integrity.",
          },
        ],
      },
      {
        description: "How do you create a database and a table in MySQL?",
        content: [
          {
            type: "code",
            value:
              "CREATE DATABASE mydb;\nUSE mydb;\nCREATE TABLE users (id INT PRIMARY KEY, name VARCHAR(50));",
          },
        ],
      },
      {
        description: "What is the difference between CHAR and VARCHAR?",
        content: [
          {
            type: "text",
            value:
              "- **CHAR**: Fixed-length string storage.\n- **VARCHAR**: Variable-length string storage.",
          },
        ],
      },
      {
        description:
          "What is the difference between DELETE, TRUNCATE, and DROP?",
        content: [
          {
            type: "text",
            value:
              "- **DELETE**: Removes specific rows.\n- **TRUNCATE**: Removes all rows but keeps the structure.\n- **DROP**: Deletes the entire table.",
          },
        ],
      },
      {
        description: "How do you alter an existing table in MySQL?",
        content: [
          {
            type: "code",
            value: "ALTER TABLE users ADD COLUMN age INT;",
          },
        ],
      },
      {
        description: "How do you copy a table structure without copying data?",
        content: [
          {
            type: "code",
            value: "CREATE TABLE new_table LIKE old_table;",
          },
        ],
      },
      {
        description: "How do you retrieve all records from a table?",
        content: [
          {
            type: "code",
            value: "SELECT * FROM users;",
          },
        ],
      },
      {
        description: "What is the difference between WHERE and HAVING?",
        content: [
          {
            type: "text",
            value:
              "- **WHERE**: Filters rows before aggregation.\n- **HAVING**: Filters rows after aggregation.",
          },
        ],
      },
      {
        description: "How does GROUP BY work in MySQL?",
        content: [
          {
            type: "code",
            value:
              "SELECT department, COUNT(*) FROM employees GROUP BY department;",
          },
        ],
      },
      {
        description: "What are the different types of joins in MySQL?",
        content: [
          {
            type: "text",
            value:
              "- **INNER JOIN**: Matches rows from both tables.\n- **LEFT JOIN**: Includes all left table rows.\n- **RIGHT JOIN**: Includes all right table rows.\n- **FULL JOIN**: Includes all rows from both tables.",
          },
        ],
      },
      {
        description:
          "What is the difference between INNER JOIN, LEFT JOIN, and RIGHT JOIN?",
        content: [
          {
            type: "text",
            value:
              "- **INNER JOIN**: Returns matching rows from both tables.\n- **LEFT JOIN**: Returns all rows from the left table and matching rows from the right.\n- **RIGHT JOIN**: Returns all rows from the right table and matching rows from the left.",
          },
        ],
      },
      {
        description: "What is an index, and how does it improve performance?",
        content: [
          {
            type: "text",
            value:
              "An index speeds up queries by allowing faster lookups in a database.",
          },
        ],
      },
      {
        description:
          "What is the difference between a clustered and non-clustered index?",
        content: [
          {
            type: "text",
            value:
              "- **Clustered Index**: Sorts and stores data rows physically.\n- **Non-clustered Index**: Stores only a reference to data rows.",
          },
        ],
      },
      {
        description: "How do you create and remove an index in MySQL?",
        content: [
          {
            type: "code",
            value:
              "CREATE INDEX idx_name ON users(name);\nDROP INDEX idx_name ON users;",
          },
        ],
      },
      {
        description: "How do you optimize slow queries in MySQL?",
        content: [
          {
            type: "text",
            value:
              "- Use indexes.\n- Avoid SELECT *.\n- Optimize joins.\n- Use EXPLAIN to analyze queries.",
          },
        ],
      },
      {
        description: "What is the EXPLAIN command, and how is it used?",
        content: [
          {
            type: "code",
            value: "EXPLAIN SELECT * FROM users WHERE age > 30;",
          },
        ],
      },
      {
        description: "What is a transaction, and how do you use it in MySQL?",
        content: [
          {
            type: "code",
            value:
              "START TRANSACTION;\nUPDATE accounts SET balance = balance - 100 WHERE id = 1;\nUPDATE accounts SET balance = balance + 100 WHERE id = 2;\nCOMMIT;",
          },
        ],
      },
      {
        description: "What is the difference between COMMIT and ROLLBACK?",
        content: [
          {
            type: "text",
            value:
              "- **COMMIT**: Saves all changes.\n- **ROLLBACK**: Undoes all changes in the transaction.",
          },
        ],
      },
      {
        description: "What are isolation levels in MySQL transactions?",
        content: [
          {
            type: "text",
            value:
              "- **Read Uncommitted**: Allows dirty reads.\n- **Read Committed**: Prevents dirty reads.\n- **Repeatable Read**: Prevents non-repeatable reads.\n- **Serializable**: Prevents all concurrency issues.",
          },
        ],
      },
      {
        description: "What is a deadlock, and how can you prevent it?",
        content: [
          {
            type: "text",
            value:
              "A deadlock occurs when two transactions block each other. Prevention methods include proper indexing, locking strategies, and timeout settings.",
          },
        ],
      },
      {
        description: "What is MySQL replication, and how does it work?",
        content: [
          {
            type: "text",
            value:
              "MySQL replication synchronizes data between a primary and one or more secondary databases.",
          },
          {
            type: "code",
            value:
              "CHANGE MASTER TO MASTER_HOST='master_host', MASTER_USER='replica_user', MASTER_PASSWORD='password';",
          },
        ],
      },
      {
        description: "What is MongoDB, and how does it differ from MySQL?",
        content: [
          {
            type: "text",
            value:
              "MongoDB is a NoSQL database that stores data in flexible JSON-like documents, while MySQL is a relational database that uses structured tables.",
          },
        ],
      },
      {
        description:
          "What are the advantages of using MongoDB over a relational database?",
        content: [
          {
            type: "text",
            value:
              "- Schema-less design\n- Horizontal scaling\n- High performance with large datasets\n- Easier handling of unstructured data",
          },
        ],
      },
      {
        description: "What is BSON, and how is it different from JSON?",
        content: [
          {
            type: "text",
            value:
              "BSON (Binary JSON) is a binary format used by MongoDB that supports additional data types like Date and ObjectId.",
          },
        ],
      },
      {
        description: "What are collections and documents in MongoDB?",
        content: [
          {
            type: "text",
            value:
              "A **collection** is a group of documents, similar to a table in SQL. A **document** is a JSON-like object containing key-value pairs.",
          },
        ],
      },
      {
        description: "What are the different data types supported in MongoDB?",
        content: [
          {
            type: "text",
            value:
              "MongoDB supports String, Number, Boolean, Array, Object, Date, ObjectId, Binary Data, and more.",
          },
        ],
      },
      {
        description: "How do you insert a document into a MongoDB collection?",
        content: [
          {
            type: "code",
            value: "db.users.insertOne({ name: 'John Doe', age: 30 });",
          },
        ],
      },
      {
        description: "How do you update a document in MongoDB?",
        content: [
          {
            type: "code",
            value:
              "db.users.updateOne({ name: 'John Doe' }, { $set: { age: 31 } });",
          },
        ],
      },
      {
        description: "How do you delete documents from a MongoDB collection?",
        content: [
          {
            type: "code",
            value: "db.users.deleteOne({ name: 'John Doe' });",
          },
        ],
      },
      {
        description: "How do you retrieve documents using find()?",
        content: [
          {
            type: "code",
            value: "db.users.find({ age: { $gt: 25 } });",
          },
        ],
      },
      {
        description: "What is the difference between findOne() and find()?",
        content: [
          {
            type: "text",
            value:
              "- **findOne()** returns a single document.\n- **find()** returns multiple documents as a cursor.",
          },
        ],
      },
      {
        description:
          "What are some common MongoDB query operators ($eq, $gt, $lt, $in, $nin)?",
        content: [
          {
            type: "text",
            value:
              "- **$eq**: Matches values equal to a specified value.\n- **$gt**: Matches values greater than a specified value.\n- **$lt**: Matches values less than a specified value.\n- **$in**: Matches any value in an array.\n- **$nin**: Matches values not in an array.",
          },
        ],
      },
      {
        description: "How do you search for text using $regex in MongoDB?",
        content: [
          {
            type: "code",
            value: "db.users.find({ name: { $regex: '^J', $options: 'i' } });",
          },
        ],
      },
      {
        description: "What is $exists, and how is it used in queries?",
        content: [
          {
            type: "code",
            value: "db.users.find({ email: { $exists: true } });",
          },
        ],
      },
      {
        description: "How do you use the $or operator in MongoDB queries?",
        content: [
          {
            type: "code",
            value:
              "db.users.find({ $or: [{ age: { $gt: 30 } }, { name: 'John' }] });",
          },
        ],
      },
      {
        description:
          "What is the difference between $push, $addToSet, and $pull?",
        content: [
          {
            type: "text",
            value:
              "- **$push**: Adds an element to an array.\n- **$addToSet**: Adds an element only if it does not exist.\n- **$pull**: Removes an element from an array.",
          },
        ],
      },
      {
        description:
          "What is an index in MongoDB, and how does it improve query performance?",
        content: [
          {
            type: "text",
            value:
              "Indexes speed up queries by allowing MongoDB to find data more efficiently.",
          },
        ],
      },
      {
        description: "How do you create and remove an index in MongoDB?",
        content: [
          {
            type: "code",
            value:
              "db.users.createIndex({ name: 1 });\ndb.users.dropIndex({ name: 1 });",
          },
        ],
      },
      {
        description: "What are compound indexes, and how are they useful?",
        content: [
          {
            type: "text",
            value:
              "A compound index includes multiple fields to improve query performance on complex queries.",
          },
        ],
      },
      {
        description: "How does MongoDB handle large datasets efficiently?",
        content: [
          {
            type: "text",
            value:
              "MongoDB uses indexes, sharding, and replication to manage large datasets efficiently.",
          },
        ],
      },
      {
        description: "How do you use explain() to analyze query performance?",
        content: [
          {
            type: "code",
            value:
              "db.users.find({ age: { $gt: 30 } }).explain('executionStats');",
          },
        ],
      },
      {
        description: "What is replication in MongoDB, and why is it important?",
        content: [
          {
            type: "text",
            value:
              "Replication creates copies of data across multiple servers for fault tolerance and high availability.",
          },
        ],
      },
      {
        description: "What is sharding in MongoDB, and when should you use it?",
        content: [
          {
            type: "text",
            value:
              "Sharding distributes data across multiple machines to handle large-scale datasets and high traffic.",
          },
        ],
      },
      {
        description: "What is a shard key, and how is it selected?",
        content: [
          {
            type: "text",
            value:
              "A shard key determines how data is distributed in a sharded cluster. It should be chosen based on query patterns.",
          },
        ],
      },
      {
        description:
          "How do MongoDB transactions work across multiple documents?",
        content: [
          {
            type: "code",
            value:
              "const session = db.getMongo().startSession();\nsession.startTransaction();\ndb.users.updateOne({ _id: 1 }, { $set: { balance: 500 } });\ndb.accounts.updateOne({ _id: 2 }, { $set: { balance: 300 } });\nsession.commitTransaction();",
          },
        ],
      },
      {
        description: "How do you monitor MongoDB performance?",
        content: [
          {
            type: "text",
            value:
              "Use MongoDB tools like **mongostat**, **mongotop**, and **db.serverStatus()** to monitor performance.",
          },
        ],
      },
    ],
  },
  reactjs: {
    pages: [
      {
        description: "What is React.js, and why is it used?",
        content: [
          {
            type: "text",
            value:
              "**React.js** is a JavaScript library for building user interfaces, primarily for **Single Page Applications (SPAs)**. It is widely used due to its **component-based architecture, virtual DOM, and efficient rendering**.",
          },
        ],
      },
      {
        description: "What are the main features of React?",
        content: [
          {
            type: "text",
            value:
              "- **Component-based architecture**: UI is divided into reusable components.\n- **Virtual DOM**: Efficiently updates only necessary parts of the UI.\n- **Unidirectional data flow**: Ensures predictable state management.\n- **JSX syntax**: A syntax extension to write HTML inside JavaScript.\n- **React Hooks**: Enables state and lifecycle features in functional components.",
          },
        ],
      },
      {
        description:
          "What is the Virtual DOM, and how does it improve performance?",
        content: [
          {
            type: "text",
            value:
              "The **Virtual DOM** is a lightweight, in-memory representation of the real DOM. Instead of directly modifying the actual DOM, React updates the Virtual DOM first, calculates the changes, and applies only the necessary updates to the real DOM. This improves performance and minimizes unnecessary re-rendering.",
          },
          {
            type: "code",
            value:
              "const element = <h1>Hello, World!</h1>;\nReactDOM.render(element, document.getElementById('root'));",
          },
        ],
      },
      {
        description: "What is JSX, and how is it different from HTML?",
        content: [
          {
            type: "text",
            value:
              "**JSX (JavaScript XML)** is a syntax extension that allows writing HTML-like code inside JavaScript. Unlike HTML, JSX gets transpiled to JavaScript functions (e.g., `React.createElement`) before being rendered.",
          },
          {
            type: "code",
            value:
              "// JSX Example\nconst element = <h1>Hello, World!</h1>;\nReactDOM.render(element, document.getElementById('root'));\n\n// Transpiled JavaScript\nReact.createElement('h1', null, 'Hello, World!');",
          },
        ],
      },
      {
        description:
          "What is the difference between functional components and class components?",
        content: [
          {
            type: "text",
            value:
              "- **Functional components** are simple JavaScript functions that return JSX.\n- **Class components** use ES6 classes and have lifecycle methods and state.\n- **Functional components** use React Hooks (e.g., `useState`, `useEffect`) for state and lifecycle management.",
          },
          {
            type: "code",
            value:
              "// Functional Component\nconst Greeting = () => <h1>Hello, World!</h1>;\n\n// Class Component\nclass Greeting extends React.Component {\n  render() {\n    return <h1>Hello, World!</h1>;\n  }\n}",
          },
        ],
      },
      {
        description: "What is the React component lifecycle?",
        content: [
          {
            type: "text",
            value:
              "The **React component lifecycle** consists of three main phases:\n- **Mounting**: The component is created and inserted into the DOM.\n- **Updating**: The component updates due to state/prop changes.\n- **Unmounting**: The component is removed from the DOM.",
          },
        ],
      },
      {
        description:
          "What are the different lifecycle methods in class components?",
        content: [
          {
            type: "text",
            value:
              "- `componentDidMount()` - Runs after the component is inserted into the DOM.\n- `componentDidUpdate()` - Runs when the component updates.\n- `componentWillUnmount()` - Runs before the component is removed from the DOM.",
          },
        ],
      },
      {
        description:
          "What is the purpose of componentDidMount() and componentDidUpdate()?",
        content: [
          {
            type: "text",
            value:
              "- `componentDidMount()` is used for actions that should run after the component is first rendered, such as **fetching API data** or **setting up subscriptions**.\n- `componentDidUpdate()` is used when the component updates due to **state or prop changes**, useful for **triggering side effects**.",
          },
          {
            type: "code",
            value:
              "class Example extends React.Component {\n  componentDidMount() {\n    console.log('Component mounted!');\n  }\n  componentDidUpdate() {\n    console.log('Component updated!');\n  }\n  render() {\n    return <h1>Hello, React!</h1>;\n  }\n}",
          },
        ],
      },
      {
        description:
          "What is the difference between controlled and uncontrolled components?",
        content: [
          {
            type: "text",
            value:
              "- **Controlled components**: React manages the form state using `useState` or class component state.\n- **Uncontrolled components**: The DOM manages the form state using `ref`.",
          },
          {
            type: "code",
            value:
              "// Controlled Component\nconst ControlledInput = () => {\n  const [value, setValue] = React.useState('');\n  return <input value={value} onChange={(e) => setValue(e.target.value)} />;\n};\n\n// Uncontrolled Component\nconst UncontrolledInput = () => {\n  const inputRef = React.useRef();\n  return <input ref={inputRef} />;\n};",
          },
        ],
      },
      {
        description: "How do you force a React component to re-render?",
        content: [
          {
            type: "text",
            value:
              "A React component can be forced to re-render using **state updates** or the `forceUpdate()` method in class components.",
          },
          {
            type: "code",
            value:
              "// Using state to trigger re-render\nconst ForceRender = () => {\n  const [, setToggle] = React.useState(false);\n  return <button onClick={() => setToggle(t => !t)}>Re-render</button>;\n};\n\n// Using forceUpdate in class components\nclass ForceUpdateExample extends React.Component {\n  forceUpdateHandler = () => {\n    this.forceUpdate();\n  };\n  render() {\n    return <button onClick={this.forceUpdateHandler}>Force Re-render</button>;\n  }\n}",
          },
        ],
      },
      {
        description: "What are React Hooks, and why were they introduced?",
        content: [
          {
            type: "text",
            value:
              "React Hooks are **functions that allow functional components to use state and lifecycle methods**. They were introduced in React 16.8 to enable stateful logic in functional components without needing class components.",
          },
          {
            type: "code",
            value:
              "// Using useState Hook\nconst Counter = () => {\n  const [count, setCount] = React.useState(0);\n  return <button onClick={() => setCount(count + 1)}>Count: {count}</button>;\n};",
          },
        ],
      },
      {
        description: "What is useState() in React, and how does it work?",
        content: [
          {
            type: "text",
            value:
              "`useState()` is a **React Hook** that allows functional components to manage local state. It returns an **array** with two values:\n1. The **current state value**\n2. A **function to update the state**",
          },
          {
            type: "code",
            value:
              "const Counter = () => {\n  const [count, setCount] = React.useState(0);\n  return <button onClick={() => setCount(count + 1)}>Count: {count}</button>;\n};",
          },
        ],
      },
      {
        description: "What is useEffect(), and how is it used?",
        content: [
          {
            type: "text",
            value:
              "`useEffect()` is a React Hook used for **side effects** in functional components, such as **fetching data**, **subscriptions**, or **manipulating the DOM**.",
          },
          {
            type: "code",
            value:
              "React.useEffect(() => {\n  console.log('Component mounted!');\n  return () => console.log('Cleanup on unmount');\n}, []);",
          },
        ],
      },
      {
        description:
          "What is the difference between useEffect() and lifecycle methods?",
        content: [
          {
            type: "text",
            value:
              "`useEffect()` in functional components **replaces multiple lifecycle methods** in class components, such as:\n- `componentDidMount`\n- `componentDidUpdate`\n- `componentWillUnmount`",
          },
          {
            type: "code",
            value:
              "// Using useEffect in a functional component\nReact.useEffect(() => {\n  console.log('Component mounted or updated');\n  return () => console.log('Cleanup on unmount');\n}, [dependency]);\n\n// Equivalent lifecycle methods in a class component\nclass Example extends React.Component {\n  componentDidMount() {\n    console.log('Component mounted');\n  }\n  componentDidUpdate() {\n    console.log('Component updated');\n  }\n  componentWillUnmount() {\n    console.log('Component unmounted');\n  }\n}",
          },
        ],
      },
      {
        description: "How do you clean up side effects in useEffect()?",
        content: [
          {
            type: "text",
            value:
              "You return a **cleanup function** inside `useEffect()`. This function runs when the component unmounts or before the effect runs again.",
          },
          {
            type: "code",
            value:
              "React.useEffect(() => {\n  const interval = setInterval(() => {\n    console.log('Running effect');\n  }, 1000);\n  \n  return () => clearInterval(interval); // Cleanup function\n}, []);",
          },
        ],
      },
      {
        description: "What is useContext(), and how does it work?",
        content: [
          {
            type: "text",
            value:
              "`useContext()` allows components to access **context values** without using **prop drilling**.",
          },
          {
            type: "code",
            value:
              "const MyContext = React.createContext();\n\nconst Component = () => {\n  const value = React.useContext(MyContext);\n  return <p>{value}</p>;\n};",
          },
        ],
      },
      {
        description: "How do you use useReducer() for state management?",
        content: [
          {
            type: "text",
            value:
              "`useReducer()` is an alternative to `useState()` for managing **complex state logic** in functional components.",
          },
          {
            type: "code",
            value:
              "const reducer = (state, action) => {\n  switch (action.type) {\n    case 'increment':\n      return { count: state.count + 1 };\n    case 'decrement':\n      return { count: state.count - 1 };\n    default:\n      return state;\n  }\n};\n\nconst Counter = () => {\n  const [state, dispatch] = React.useReducer(reducer, { count: 0 });\n  return (\n    <div>\n      <p>Count: {state.count}</p>\n      <button onClick={() => dispatch({ type: 'increment' })}>+</button>\n      <button onClick={() => dispatch({ type: 'decrement' })}>-</button>\n    </div>\n  );\n};",
          },
        ],
      },
      {
        description: "What is useMemo(), and when should you use it?",
        content: [
          {
            type: "text",
            value:
              "`useMemo()` **memoizes expensive computations** to avoid unnecessary re-computation on each render.",
          },
          {
            type: "code",
            value:
              "const computeExpensiveValue = (num) => {\n  console.log('Computing...');\n  return num * 2;\n};\n\nconst Component = ({ num }) => {\n  const memoizedValue = React.useMemo(() => computeExpensiveValue(num), [num]);\n  return <p>{memoizedValue}</p>;\n};",
          },
        ],
      },
      {
        description: "How does useCallback() improve performance?",
        content: [
          {
            type: "text",
            value:
              "`useCallback()` **memoizes callback functions**, preventing unnecessary re-creation of functions on each render.",
          },
          {
            type: "code",
            value:
              "const Component = () => {\n  const handleClick = React.useCallback(() => {\n    console.log('Clicked!');\n  }, []);\n\n  return <button onClick={handleClick}>Click me</button>;\n};",
          },
        ],
      },
      {
        description: "What is useRef(), and how can it be used?",
        content: [
          {
            type: "text",
            value:
              "`useRef()` creates a reference to **DOM elements** or **stores values** that persist between renders without causing re-renders.",
          },
          {
            type: "code",
            value:
              "const Component = () => {\n  const inputRef = React.useRef();\n  \n  return (\n    <div>\n      <input ref={inputRef} />\n      <button onClick={() => inputRef.current.focus()}>Focus Input</button>\n    </div>\n  );\n};",
          },
        ],
      },
      {
        description: "What is the difference between props and state in React?",
        content: [
          {
            type: "text",
            value:
              "- **Props** are **immutable** and passed from parent to child.\n- **State** is **mutable** and managed **within the component**.",
          },
        ],
      },
      {
        description: "What is 'lifting state up' in React?",
        content: [
          {
            type: "text",
            value:
              "Lifting state up means moving **state from child components** to a **common parent** to share data between siblings.",
          },
          {
            type: "code",
            value:
              "const Parent = () => {\n  const [value, setValue] = React.useState('');\n  return <Child value={value} setValue={setValue} />;\n};\n\nconst Child = ({ value, setValue }) => (\n  <input value={value} onChange={(e) => setValue(e.target.value)} />\n);",
          },
        ],
      },
      {
        description: "What is Context API, and how does it work?",
        content: [
          {
            type: "text",
            value:
              "The **Context API** provides a way to **pass data through the component tree** without using **props**.",
          },
          {
            type: "code",
            value:
              "const MyContext = React.createContext();\n\nconst Provider = ({ children }) => {\n  return <MyContext.Provider value={'Hello'}>{children}</MyContext.Provider>;\n};\n\nconst Consumer = () => {\n  const value = React.useContext(MyContext);\n  return <p>{value}</p>;\n};",
          },
        ],
      },
      {
        description:
          "What is lazy loading in React, and how do you implement it?",
        content: [
          {
            type: "text",
            value:
              "Lazy loading **defers loading** of components until they are needed. It is implemented using **React.lazy()** and **Suspense**.",
          },
          {
            type: "code",
            value:
              "const LazyComponent = React.lazy(() => import('./MyComponent'));\n\nconst App = () => (\n  <React.Suspense fallback={<p>Loading...</p>}>\n    <LazyComponent />\n  </React.Suspense>\n);",
          },
        ],
      },
      {
        description:
          "How do you prevent unnecessary re-renders in React components?",
        content: [
          {
            type: "text",
            value:
              "- Use `React.memo()` for functional components.\n- Use `useMemo()` and `useCallback()` for performance optimization.\n- Avoid updating state unnecessarily.",
          },
          {
            type: "code",
            value:
              "const MemoizedComponent = React.memo(({ name }) => {\n  console.log('Rendering...');\n  return <p>Hello, {name}</p>;\n});",
          },
        ],
      },
      {
        "description": "What is React Router, and why is it used?",
        "content": [
          {
            "type": "text",
            "value": "React Router is a **library for managing navigation** and routing in React applications. It enables client-side routing and helps create **Single Page Applications (SPAs)**."
          },
          {
            "type": "code",
            "value": "import { BrowserRouter, Routes, Route } from 'react-router-dom';\n\nconst App = () => (\n  <BrowserRouter>\n    <Routes>\n      <Route path='/' element={<Home />} />\n      <Route path='/about' element={<About />} />\n    </Routes>\n  </BrowserRouter>\n);"
          }
        ]
      },
      {
        "description": "What is the difference between BrowserRouter and HashRouter?",
        "content": [
          {
            "type": "text",
            "value": "- **BrowserRouter**: Uses the **history API** and provides **clean URLs** (e.g., `/about`).\n- **HashRouter**: Uses **hash-based URLs** (e.g., `#/about`) and is useful for environments where server configuration is limited."
          }
        ]
      },
      {
        "description": "What is useNavigate() in React Router v6?",
        "content": [
          {
            "type": "text",
            "value": "`useNavigate()` is a Hook in React Router v6 that **replaces useHistory()** to navigate programmatically."
          },
          {
            "type": "code",
            "value": "import { useNavigate } from 'react-router-dom';\n\nconst Component = () => {\n  const navigate = useNavigate();\n\n  return <button onClick={() => navigate('/dashboard')}>Go to Dashboard</button>;\n};"
          }
        ]
      },
      {
        "description": "How do you handle API requests in React?",
        "content": [
          {
            "type": "text",
            "value": "You can use **fetch()** or **Axios** to make API requests inside `useEffect()` to fetch data when the component mounts."
          },
          {
            "type": "code",
            "value": "import { useEffect, useState } from 'react';\nimport axios from 'axios';\n\nconst Component = () => {\n  const [data, setData] = useState([]);\n\n  useEffect(() => {\n    axios.get('https://api.example.com/data')\n      .then(response => setData(response.data))\n      .catch(error => console.error(error));\n  }, []);\n\n  return <pre>{JSON.stringify(data, null, 2)}</pre>;\n};"
          }
        ]
      },
      {
        "description": "What is Server-Side Rendering (SSR) in React?",
        "content": [
          {
            "type": "text",
            "value": "**Server-Side Rendering (SSR)** renders React pages **on the server** before sending them to the client. This improves **performance and SEO**."
          },
          {
            "type": "code",
            "value": "import express from 'express';\nimport React from 'react';\nimport { renderToString } from 'react-dom/server';\nimport App from './App';\n\nconst server = express();\n\nserver.get('*', (req, res) => {\n  const html = renderToString(<App />);\n  res.send(`<!DOCTYPE html><html><body><div id='root'>${html}</div></body></html>`);\n});\n\nserver.listen(3000, () => console.log('Server running on port 3000'));"
          }
        ]
      },
      {
        "description": "How do you implement authentication in React?",
        "content": [
          {
            "type": "text",
            "value": "- Use **JWT (JSON Web Token)** for token-based authentication.\n- Use **Firebase authentication**.\n- Manage authentication state using **React Context** or **Redux**."
          },
          {
            "type": "code",
            "value": "import { useState, useEffect } from 'react';\nimport axios from 'axios';\n\nconst useAuth = () => {\n  const [user, setUser] = useState(null);\n\n  useEffect(() => {\n    const token = localStorage.getItem('token');\n    if (token) {\n      axios.get('/api/user', { headers: { Authorization: `Bearer ${token}` } })\n        .then(res => setUser(res.data))\n        .catch(() => setUser(null));\n    }\n  }, []);\n\n  return user;\n};"
          }
        ]
      },
      {
        "description": "What are React Portals, and when should you use them?",
        "content": [
          {
            "type": "text",
            "value": "React **Portals** allow rendering a component **outside the main DOM hierarchy**. They are useful for **modals, tooltips, and pop-ups**."
          },
          {
            "type": "code",
            "value": "import ReactDOM from 'react-dom';\n\nconst Modal = ({ children }) => {\n  return ReactDOM.createPortal(\n    <div className='modal'>{children}</div>,\n    document.getElementById('modal-root')\n  );\n};"
          }
        ]
      }
    ],
  },
  socketIo: {
    pages: [],
  },
  graphql: {
    pages: [],
  },
  sdlc: { // agile, scrum, waterfall, kanban, lean, xp, devops, spiral, v-model, rup, scrumban, crystal, fdd, dsdm, pmbok, prince2, msp, ipma
    pages: [],
  },
  others: { // ci/cd, devops, jenkins, git, docker, kubernetes, 
    pages: [],
  }
};
